/*global $, document, window, setTimeout, alert, FG*/

(function () {
    'use strict';

    var CSRF_TOKEN = FG.Utils.getToken();
    var MY_COUNTRIES_ARRAY = ['United States', 'Mexico', 'Canada'];
    var MY_BILLING_TYPES_ARRAY = {'mastercard':'Mastercard', 'visa':'Visa', 'amex':'American Express', 'jcb':'JCB', 'diners':'Diners', 'discover':'Discover', 'paypal':'Paypal','unionpay':'Union Pay'}
    var MY_SUBMIT_DATA_ARRAY = ['firstName', 'lastName', 'ccNumber', 'ccSecurityCode', 'ccExpMonth', 'ccExpYear', 'ccType'];

    var PLAN_SCHEDULE_CONTAINER = 'payment-schedule-main';

    // Marks .order_confirmation_text as carrying an Apple Pay billing error, so it
    // can be cleared on retry without wiping a message another consumer of that
    // shared banner put there. Carries no styling of its own — see
    // showApplePayBillingError().
    var APPLEPAY_BILLING_ERROR_CLASS = 'applepay-billing-error';

    var _venmoUsername = null;
    var _googlePayUserEmail = null;
    var _paypalUserEmail = null;
    var isSMSConsent = false;
    var _hasExistingBillingAddress = false;
    var _isDeliveryOptionMail = false;

    window.dataLayer = window.dataLayer || [];


    /**
     * Handle all checkout related functionality
     * @since 8/15/2013
     * @returns {*}
     * @constructor
     */
    FG.Checkout = function () {

        $('#shipping_country').focus(function() {
            $(this).removeAttr('readonly');
            $('#shipping_country').unbind('blur').blur(function(){
                $(this).attr('readonly', true);
            })
        });

        // Root URL with label
        this.labelRoot = $('link[rel="label_root"]').attr('href');
        // Name of the label that we are currently on
        this.labelName = $('#labelName').val();

        return this;
    };

    // Object to store user data to make a purchase
    FG.SubmitData = {};

    FG.Checkout.prototype = {
        constructor: FG.Checkout(), // constructor: FG.Checkout Indicate that this is a constructor
        labelRoot: null, // labelRoot: String Root URL for label
        labelName: null, // labelName: String Label name for the current label we are on
        Ajax: undefined, // Ajax: FG.Ajax FrontGate Ajax object for request funneling
        isNextStep: false, // boolean Tracks when the Next button is pressed
        xTicketCount: 0,
        sentArray: [],
        collapsedOptions: false,
        maxJobRetry: 7,
        paypalReset: false,
        checkout: false,
        clientInstance: false,
        braintreeAPI: null,

        //Hydrate any properties on this object. Instantiate Ajax object
        hydrate: function () { this.Ajax = new FG.Ajax('dev/null'); },

        // Run all methods needed on the checkout page
        run: function (acceptedCards, labelName, braintreeStored) {
            FGTLibs.Kount.setup($('#kountSession').attr('data-value'), $('#TestGateway').attr('data-value'));

            this.isThreeDSecureEnabled = $('#use_secure').length > 0;
            this.isPaypalEnabled = $('#paypal-button-container').length > 0;
            this.isGooglePayEnabled = $('#google-button-container').length > 0;
            this.canUseVenmo = $('input#canUseVenmo').length > 0;

            var insuranceAvailable = !$('#insurance_form').hasClass('hidden');
            var SHIPPING_STEP = 2;
            var BILLING_STEP = 3;

            $.extend(this, {
                acceptedCards: acceptedCards,
                labelName: labelName,
                insuranceAvailable: !insuranceAvailable,
                deviceData: false
            });

            this.bindToOrderSummaryDetails(); // Bind to the drop-down arrow links in the order summary pane
            this.bindToShippingCountry(); // refresh shipping dropdown on shipping options change
            this.buildShippingOptionsDD({ 'countryName': $('#shipping_country').val() }); // Build shipping options drop-down
            this.bindToShippingForm(); // Bind to the click event for the delivery form
            this.bindToCVCHelpWindow(); // Bind to the credit card CVC help window
            this.bindToBillingCountry(); // bind to bulling country refresh state list
            this.buildBillingCountryStateDD({ countryName: $('#shipping_country').val() }); //fetch state for billing country
            this.bindInsuranceHandlers(); //Set up insurance handlers
            this.bindToCreateAccount(); // bind to create new password field if new account is checked
            this.unbindFromCVCHelpWindow(); //Brings focus back to the triggering element on unbind (for screen readers)

            // Bind to the click event for the billing form

            _hasExistingBillingAddress = $('#billing_address').val().length > 0;
            // copyShippingToBilling should still happen for zero dollar forms whether or not
            // they're part of Braintree.
            if ($('#braintree_token').val() && !_hasExistingBillingAddress) {
                this.copyShippingToBilling();
            }

            if (this.currentStep() === SHIPPING_STEP || this.currentStep() === BILLING_STEP) {
                this.setupBraintree();
            }

            this.bindToInsuranceForm(); // Bind to the insurance form
            this.bindToInsuranceTermsWindow(); // Click event for the terms and conditions modal for insurance
            this.ensurePaymentPlanSelections(); // Ensure all prior user selections for layaway plan are maintained
            this.activateNewPP(); // Activate the upgraded PP UI
            this.bindToPaymentPlanDropdown(); //Bind to the layaway plan radio button
            this.bindToPayInFullRadio(); // Bind to the pay in full radio button for layaway plan
            this.bindToStoredCard(); // Bind to stored card links, if turned on
            this.bindToPurchaseForm(); // Bind to the click event for the purchase form
            this.bindToTermsModal(); // Bind to the terms modal window
            this.bindToPPTermsModal(); // Bind to the layaway plan terms modal window

            $('.panel-group').find('a.head.accordion-toggle').click(function (e) {
                var $accordionGroup = $(this).closest('div.panel.panel-default');
                if (!FG.Checkout.isNextStep && !$accordionGroup.hasClass('complete')) {
                    e.stopPropagation();
                    return false;
                }
                $accordionGroup.nextAll().removeClass('complete');
                FG.Checkout.isNextStep = false;
            });

            function venmoLayoutUpdater() {
                if ($('input#canUseVenmo').length > 0) {
                    FGTLibs.UpdateCheckout.updatePaymentMethodsLayoutForVenmo();
                }
            }
            venmoLayoutUpdater();

            // Manually initialize popovers
            $('[data-toggle="popover"]').popover({trigger: 'hover focus'});

            // Run the jQuery popover initializer when the Order Summary html changes
            var mutationTarget = document.getElementById('order_summary_fragment');
            var mutationConfig = { childList: true };
            function popoverMutationCallback() {
                $('[data-toggle="popover"]').popover({trigger: 'hover focus'});
            }
            var observer = new MutationObserver(popoverMutationCallback);
            observer.observe(mutationTarget, mutationConfig);

        },

        currentStep: function() {
            if ($('#acc-step-three').hasClass('complete')) return 4;
            if ($('#acc-step-two').hasClass('complete')) return 3;
            if ($('#acc-step-one').hasClass('complete')) return 2;
            return 1;
        },

        sendStepAndActionToECommerce: function(step, option) {
            dataLayer.push({
                'event': 'checkoutOption',
                ecommerce: { checkout_option: { actionField: { step: step, option: option } } }
            });
        },

        isValueValid: function(value) { return value != '' && value != undefined && value.length != 0; },

        ifNotSetReplace: function (element, value) {
            if (!this.isValueValid(element.val())) { element.val(value); }
        },

        luhnChk : (function (arr) {
            return function (ccNum) {
                var len = ccNum.length, bit = 1,  sum = 0, val;
                while (len) {
                    val = parseInt(ccNum.charAt(--len), 10);
                    sum += (bit ^= 1) ? arr[val] : val;
                }
                return sum && sum % 10 === 0;
            };
        }([0, 2, 4, 6, 8, 1, 3, 5, 7, 9])),

        /**
         * Toggle visibility between Apple Pay purchase button and regular purchase button
         * @param {boolean} showApplePay - true to show Apple Pay button, false to show regular button
         */
        toggleApplePayButtonVisibility: function(showApplePay) {
            if (showApplePay) {
                $('#purchase_tickets').addClass('hide');
                $('#apple-pay-purchase-container').removeClass('hide');
            } else {
                $('#purchase_tickets').removeClass('hide');
                $('#apple-pay-purchase-container').addClass('hide');
            }
        },

        /** Show the Apple Pay purchase button only once <apple-pay-button> has upgraded (un-upgraded
         *  = 0x0 over a hidden #purchase_tickets, FANEX-1097) and Apple Pay is still active at fire time.
         *  @param {Function} [onShown] - Runs after the button is shown (e.g. re-init Braintree) */
        showApplePayButtonWhenUsable: function(onShown) {
            var self = this;

            // Both gates below can fire on a session that resumed already on APPLEPAY
            // (#after_payment_refresh seeds it from the persisted ccType). Hiding the button
            // is not enough there: activePayment would stay APPLEPAY with no nonce, and the
            // regular purchase button then posts a confirm CheckoutHandler rejects outright.
            var handleUnusable = function() {
                if (self.paymentTracker.activePayment === FGTLibs.Payments.PaymentType.APPLEPAY) {
                    // Hides the button itself, so no toggle needed on this branch.
                    self.restorePaymentStepForApplePayDeadEnd(window.FGTLibs.i18n.t(
                        'Apple Pay is not available in this browser. Please choose a different payment method.'));
                    return;
                }

                self.toggleApplePayButtonVisibility(false);
            };

            if (!FGTLibs.Payments.BraintreeAPI.isApplePayAvailable()) {
                handleUnusable();
                return;
            }

            // canUseApplePay=false means apple_pay_sdk.twig emitted no <script>, so
            // <apple-pay-button> can never upgrade and whenApplePayElementReady() never
            // settles — in Safari isApplePayAvailable() is still true off native
            // ApplePaySession, so the gate above does not catch it. The script's absence is
            // the only signal available synchronously: a promise that never settles fires
            // no callback to hook a reset onto.
            if (!document.querySelector('script[src*="apple-pay-sdk"]')) {
                handleUnusable();
                return;
            }

            FGTLibs.Payments.BraintreeAPI.whenApplePayElementReady().then(function() {
                if (self.paymentTracker.activePayment !== FGTLibs.Payments.PaymentType.APPLEPAY) {
                    return;
                }

                self.toggleApplePayButtonVisibility(true);

                if (onShown) {
                    onShown();
                }
            }).catch(function(err) {
                // Off this promise an onShown throw is a silent unhandled rejection, so log it.
                FGTLibs.Bugsnag.log(err);
            });
        },

        /**
         * Hand an Apple Pay dead end back to the card form.
         *
         * For the failures that will recur identically on a retry, so telling the
         * customer to try again would loop them forever. Restores the regular
         * purchase button and reopens the payment step, mirroring the applePay()
         * init-failure path, so "choose a different payment method" is something
         * they can actually act on.
         *
         * #nonce is cleared because the sheet has already authorized against it: a
         * stray #confirm_form submit must not purchase with it, and purchaseTickets()
         * reads the nonce straight off the DOM rather than the serialized form.
         *
         * activePayment goes back to CARD along with the UI, which
         * displayHostedFields() does as its first statement — the tracker is what
         * validateHandler and purchaseTickets branch on, so leaving it on APPLEPAY
         * would send the re-selected card payment down the Apple Pay branch with no
         * nonce.
         *
         * #div-card-on-file is unhidden here rather than left to
         * displayHostedFields(). displayApplePay() hid it and it is not a
         * summary strip — it wraps the entire card form
         * (braintree-billing-credit-card.twig:21-217, including #name-inputs,
         * .billing-address and #billing_zip). displayHostedFields() only unhides
         * descendants of it, so without this the payment step expands onto no fields
         * at all and clicking Credit Card does not help. This is where these paths
         * differ from the applePay() init failure they otherwise mirror: that one
         * runs before any method was selected, so it had no Apple Pay UI to undo.
         *
         * An object method rather than a setupBraintree() local because
         * showApplePayButtonWhenUsable() is a sibling method and needs it too; it
         * captured nothing from that closure. displayHostedFields() is attached to the
         * instance by setupBraintree(), which every caller runs inside or after.
         *
         * @param {string} message Customer-facing, already translated.
         */
        restorePaymentStepForApplePayDeadEnd: function(message) {
            $('#nonce').val('');
            this.toggleApplePayButtonVisibility(false);
            $('#div-card-on-file').removeClass('hide');
            this.displayHostedFields();
            this.makeStepActive('collapseTwo');
            // Reported on the payment step's own message div, not the confirm
            // banner: makeStepActive('collapseTwo') has just collapsed the confirm
            // step, so a message rendered there would be hidden.
            FG.Utils.showError('msg-billing', message);
        },

        /**
         * Enable or disable the Apple Pay purchase button
         * @param {boolean} enabled - true to enable button, false to disable
         */
        setApplePayButtonEnabled: function(enabled) {
            var $applePayContainer = $('#apple-pay-purchase-container');
            var $applePayButton = $('#apple-pay-purchase');

            if (enabled) {
                $applePayContainer.removeClass('disabled');
                $applePayButton.attr('aria-disabled', 'false');
            } else {
                $applePayContainer.addClass('disabled');
                $applePayButton.attr('aria-disabled', 'true');
            }
        },

        setupBraintree: function() {
            var self = this;

            // setupBraintree() internals should only be run once during Checkout's life span
            // Continue only if Checkout.braintreeAPI has not been set
            if (self.braintreeAPI) {
                return false;
            }

            /**
             * Adding some functions to FG.Checkout
             */
            self.displayHostedFields = displayHostedFields;
            self.setupBillingValidator = setupBillingValidator;

            $('#creditCardPmButton')
                .unbind()
                .click(function(e) {
                    e.preventDefault();
                    self.displayHostedFields();
                    self.displaySameAsShippingOption();
                });

            $('#apple-pay-selection')
                .unbind()
                .click(function(e) {
                    e.preventDefault();
                    displayApplePay();
                });

            var Payments = FGTLibs.Payments;
            var PaymentType = Payments.PaymentType;
            var methods = [PaymentType.CARD];
            if (self.isPaypalEnabled) {
                methods.push(PaymentType.PAYPAL);
            }
            if ($('input#canUseVenmo').length > 0) {
                methods.push(PaymentType.VENMO);
            }
            if (self.isGooglePayEnabled){
                methods.push(PaymentType.GOOGLEPAY);
            }
            if (FGTLibs.Payments.BraintreeAPI.isApplePayAvailable()) {
                methods.push(PaymentType.APPLEPAY);
            }

            self.paymentTracker = new Payments.PaymentTracker(methods);

            self.braintreeAPI = new FGTLibs.Payments.BraintreeAPI({
                auth: $('#braintree_token').val(),
                callbacks: {
                    onCardTypeChange: onCardTypeChange,
                    onValidityChange: onValidityChange,
                    onBlur: onBlur,
                    onFocus: onFocus,
                    onPaypalTokenize: onPaypalTokenize,
                    onGoogleTokenize: onGoogleTokenize,
                    onApplePayTokenize: onApplePayTokenize,
                    // Read at session time, not now: bindToBillingCountry rebuilds
                    // these options when the customer changes country, so the list
                    // must be the one on the page when the sheet opens.
                    getAvailableCountryNames: function() {
                        return getOptionValues($('#billing_country'));
                    },
                    // Also read at session time: save_insurance re-renders
                    // #order_summary_fragment, which is what carries #SecureAdd
                    // (allianz-json-form.twig), so the flag does not exist in its
                    // final form until the insurance step has completed.
                    isInsuranceIncluded: function() {
                        return $('#SecureAdd').val() === '1';
                    },
                    onBinAvailable: onBinAvailable,
                },
            });

            //quote needs to be call when promo is applied to quoting with the new price
            var promoVenmo = $('#methodPayment').val();
            Allianz.promoAllianz(self.paymentTracker.activePayment, this.currentStep(), promoVenmo);

            $('#payment_form')
                .off('submit')
                .on('submit', function(e) {
                    e.preventDefault();
                    self.laddaBtnBillingSubmit = new FG.Ladda($('#btn-billing-submit').get(0));

                    if (self.isFreeBraintree()) {
                        freeValidateHandler.call(self);
                    } else {
                        validateHandler.call(self);
                    }

                });

            if (self.isFreeBraintree()) {
                var config = [
                    { id: 'billing_firstName_free', type: ['required', 'noHTML'] },
                    { id: 'billing_lastName_free', type: ['required', 'noHTML'] },
                    { id: 'billing-intl-phone-input', type: ['required', 'noHTML'] },
                    { id: 'billing_address', type: ['required', 'noHTML'] },
                    { id: 'billing_address2', type: ['noHTML'] },
                    { id: 'billing_city', type: ['required', 'noHTML'] },
                    { id: 'billing_zip', type: ['required', 'noHTML'] },
                ];
                self.setupBillingValidator(config);
                return true;
            };

            if ($('#after_payment_refresh').length) {
                refreshedPage()
                    .then(function(result) {
                        if (result && result.data && result.data.ccType) {
                            var ccType = result.data.ccType.toLowerCase();

                            if (ccType === 'applepay') {
                                self.paymentTracker.activePayment = FGTLibs.Payments.PaymentType.APPLEPAY;

                                // Same gate as the save_billing path: a session can resume where
                                // the SDK never loads, and a raw toggle would hide
                                // #purchase_tickets behind an un-upgraded <apple-pay-button>.
                                self.showApplePayButtonWhenUsable();
                            } else if (
                                ccType !== 'paypal' &&
                                ccType !== 'venmo' &&
                                ccType !== 'googlepay'
                            ) {
                                self.paymentTracker.activePayment = FGTLibs.Payments.PaymentType.CARD;

                                var nonce = result.data.usingStoredCard ? $('#three_d_nonce').val() : result.data.nonce;
                                var cardBin = $('#card_bin').val();

                                self.braintreeAPI.updateNonceBin({
                                    nonce: nonce,
                                    bin: cardBin,
                                });
                            }
                        }
                    })
                    .catch(function(error) {
                        FGTLibs.Bugsnag.log(error);
                    });
            }

            var dataCollectorOptions =
                !self.isPaypalEnabled
                    ? null
                    : {
                        paypal: self.isPaypalEnabled,
                    };

            self.braintreeAPI
                .createInstance({
                    methods: methods,
                    enableThreeDSecure: self.isThreeDSecureEnabled,
                    dataCollectorOptions: dataCollectorOptions,
                })
                .then(function(result) {
                    if (Array.isArray(result.methods) && result.methods.indexOf(PaymentType.VENMO) > -1) {
                        var venmoButton = document.getElementById('venmoPaymentButton');
                        venmoButton.addEventListener('click', venmoClickHandler);
                    }
                    self.deviceData = result.deviceData;

                    // Render the hosted fields if there's a stored card on page load
                    // and no other payment methods are enabled on the label
                    if ($('#div-card-on-file.cardonfile').length && !self.isPaypalEnabled && !self.canUseVenmo && !self.isGooglePayEnabled) {
                        self.displayHostedFields();
                    }
                });

            /**
             * Implementation Functions
             */

            function refreshedPage() {
                var options = {
                    path: 'checkout/refresh',
                    parameters: '',
                    wait: 0,
                };
                return FGTLibs.API.post(options);
            }

            /**
             * Attempts to remove a hide related class that could be on the Billing Submit button because the stored card is invalid
             */
            function unhideBillingSubmitButton() {
                $("#btn-billing-submit,#link-ppterms-modal-force,[name='billingPhone'],#div-cvv").removeClass('hideDiv');
            }

            function displayHostedFields() {
                var self = this;
                self.paymentTracker.activePayment = FGTLibs.Payments.PaymentType.CARD;

                var config = [
                    { id: 'billing_firstName', type: ['required', 'noHTML'] },
                    { id: 'billing_lastName', type: ['required', 'noHTML'] },
                    { id: 'billing-intl-phone-input', type: ['required', 'noHTML'] },
                    { id: 'billing_address', type: ['required', 'noHTML'] },
                    { id: 'billing_address2', type: ['noHTML'] },
                    { id: 'billing_city', type: ['required', 'noHTML'] },
                    { id: 'billing_zip', type: ['required', 'noHTML'] },
                ];
                self.setupBillingValidator(config);

                $('#div-card-on-file').css('background-color', '');

                if ($('#doNotUseStoredCard').val() == '-1') {
                    var currentStoredCardType = $('#currentStoredCardType').val();
                    if (currentStoredCardType == '-1') {
                        $('#doNotUseStoredCard').val('2');
                    } else if (currentStoredCardType == 'paypal' || currentStoredCardType === 'googlepay') {
                        $('#doNotUseStoredCard').val('1');
                    } else {
                        $('#doNotUseStoredCard').val('0');
                    }
                }
                $('#creditCardPmButton').removeClass('disabled').addClass('enabled').prop('checked',true);
                $('#card-static, #ccnumber-static, #card-number, #div-form-paid').removeClass('hide');
                $('#div-card-on-file').removeClass('googlePaySummary');
                $('#pplogo-static, #ppinfo-static, #googlePayLogo, #gpayinfo-static, #guest-payment-container').addClass('hide');

                if ($('#doNotUseStoredCard').val() > 0) {
                    $('.cardonfile').removeClass('cardonfile').addClass('nocardonfile');
                    $('.billing-address, [name="billingPhone"], #name-inputs, #div-stored-card-option, #card-save-message, #title-card-details').removeClass('hide');
                    $('#paypal-save-message').addClass('hide');
                    $('#googlepay-save-message').addClass('hide');
                } else {
                    $('.nocardonfile').removeClass('nocardonfile').addClass('cardonfile');
                    $('.billing-address, #name-inputs, #div-stored-card-option, #title-card-details').addClass('hide');
                    $('#billing_ccType').parent().removeClass('unknown ' + Object.keys(MY_BILLING_TYPES_ARRAY).join(' ')
                    ).addClass($('#cardIcon').attr('class'));
                }
            }

            function setupBillingValidator(config) {
                var self = this;

                if (self.billingValidator) {
                    return true;
                }

                var highlightInput = function(element, validation) {
                    var msgId = $(element)
                        .attr('id')
                        .concat('-error');

                    if (
                        $(element)
                            .parents('form')
                            .find('div#' + msgId).length > 0
                    ) {
                        $(element).attr('aria-describedby', '');
                        $(element)
                            .parents('form')
                            .find('div#' + msgId)
                            .remove();
                    }

                    $(element)[validation.pass ? 'removeClass' : 'addClass']('invalid');
                    $(element)
                        .parent()
                    [validation.pass ? 'removeClass' : 'addClass']('invalid');

                    if (!validation.pass && ($(element).attr('id') === 'billing-intl-phone-input')) {
                        $('#billing_phone_error').addClass('hidden');
                        $('#billing_phone_free_error').addClass('hidden');
                        $('#missing_billing_phone_error').removeClass('hidden');
                        $('#missing_billing_phone_error_free').removeClass('hidden');
                    }

                    if (!validation.pass && validation.message !== '') {
                        var msgAttr = validation.message.toLowerCase().replace(/\s/g, '_');
                        if (
                            $(element)
                                .parents('form')
                                .find('div#' + msgId).length == 0
                        ) {
                            $(element).attr('aria-describedby', msgId);
                            $(element)
                                .parent()
                                .append(
                                    '<div id="' +
                                        msgId +
                                        '" class="error-msg invalid" data-msg-text="' +
                                        msgAttr +
                                        '">' +
                                        validation.message +
                                        '</div>'
                                )
                                .show();
                        }
                        $("#btn-billing-submit").attr("aria-describedby",msgId);
                    }
                };

                self.billingValidator = new FGTLibs.InputValidator(
                    config,
                    highlightInput
                );
            }

            function displayPaypal() {
                $('#doNotUseStoredCard').val("1");
                unhideBillingSubmitButton();
                if ($('#div-stored-card-option').length) {
                    var noLayaway = !$('#paymentPlanId').length || $('#paymentPlanId').val() == "";
                    $('#div-stored-card-option').toggleClass('hide', noLayaway);
                    $('#billing_ccSave').prop('checked', !noLayaway);
                }
                $('#creditCardPmButton').addClass('disabled').removeClass('enabled').prop('checked',false);
                $('.nocardonfile').toggleClass('nocardonfile').addClass('cardonfile');
                $('.billing-address, #name-inputs, #card-static, #ccnumber-static, #card-number, #card-save-message, #gpayinfo-static, #googlepay-save-message, #title-card-details').addClass('hide');
                $('#gpaylogo-static').addClass('hide');
                $('#pplogo-card-info, #pplogo-static, #ppinfo-static, #guest-payment-container, #div-form-paid, #payment_form, #paypal-save-message').removeClass('hide');
            }

            function displayGooglePay(){
                $('#doNotUseStoredCard').val("1");
                unhideBillingSubmitButton();
                if ($('#div-stored-card-option').length) {
                    var noLayaway = !$('#paymentPlanId').length || $('#paymentPlanId').val() == "";
                    $('#div-stored-card-option').toggleClass('hide', noLayaway);
                    $('#billing_ccSave').prop('checked', !noLayaway);
                }
                $('#creditCardPmButton').addClass('disabled').removeClass('enabled').prop('checked',false);
                $('.nocardonfile').toggleClass('nocardonfile').addClass('cardonfile');
                $('.billing-address, #name-inputs, #card-static, #ccnumber-static, #card-number, #card-save-message, #ppinfo-static, #paypal-save-message, #title-card-details').addClass('hide');
                $('#pplogo-static').addClass('hide');
                $('#gpaylogo-static, #googlePayLogo, #gpayinfo-static, #guest-payment-container, #div-form-paid, #payment_form, #googlepay-save-message').removeClass('hide');
            }

            function displayApplePay() {
                self.paymentTracker.activePayment = FGTLibs.Payments.PaymentType.APPLEPAY;

                $('#doNotUseStoredCard').val("1");
                unhideBillingSubmitButton();

                if ($('#div-stored-card-option').length) {
                    var noLayaway = !$('#paymentPlanId').length || $('#paymentPlanId').val() == "";
                    $('#div-stored-card-option').toggleClass('hide', noLayaway);
                    $('#billing_ccSave').prop('checked', !noLayaway);
                }

                $('#creditCardPmButton').addClass('disabled').removeClass('enabled').prop('checked', false);
                $('.nocardonfile').toggleClass('nocardonfile').addClass('cardonfile');
                // Hide all payment input fields
                $('#div-card-on-file, .billing-address, [name="billingPhone"]').addClass('hide');
                $('#pplogo-static, #gpaylogo-static').addClass('hide');
                $('#guest-payment-container, #div-form-paid, #payment_form').removeClass('hide');

                // Automatically continue after Apple Pay selection
                // Check for layaway button (forcePPTermsToggle changes ID to link-ppterms-modal-force)
                var $submitBtn = $('#link-ppterms-modal-force').length ? $('#link-ppterms-modal-force') : $('#btn-billing-submit');
                $submitBtn.click();
            }

            function venmoClickHandler(event) {
                event.preventDefault();

                self.braintreeAPI.tokenizeVenmo()
                    .then(function(payload) {
                        onVenmoTokenize(payload);
                    });
            }

            function onCardTypeChange(event) {
                if (event.cards.length === 1) {
                    if (isCardAccepted(event.cards[0].type)) {
                        $('#card-type').removeClass();
                        $('#card-type').addClass(event.cards[0].niceType.toLowerCase().replace(/\s+/g, ''));
                        // #link-ppterms-modal-force will override the billing submit button if you
                        // switch from Pay with layaway to Pay Now and back to Pay with layaway
                        $('#btn-billing-submit, #link-ppterms-modal-force').removeClass('disabled');
                        $('#btn-billing-submit, #link-ppterms-modal-force').prop('disabled', false);
                        $('#billing_cc_error').addClass('hidden').addClass('hide').html('');

                    } else {
                        var msg = window.FGTLibs.i18n.t(
                          'Sorry, {{ labelName }} does not accept this card type.',
                          { labelName: self.labelName }
                        );
                        var errorMsg = "<i class='fa fa-exclamation-triangle fa-2x'></i><p>" + msg + "</p>";
                        $('#btn-billing-submit, #link-ppterms-modal-force').addClass('disabled');
                        $('#btn-billing-submit, #link-ppterms-modal-force').prop('disabled', true);
                        $('#billing_cc_error').removeClass('hidden').removeClass('hide').html(errorMsg);
                    }
                } else {
                    $('#card-type').removeClass();
                }
            }

            function isCardAccepted(cardType) {
                var braintreeToInternalMapping = {
                    'american-express': 'A',
                    'diners-club': 'C',
                    discover: 'D',
                    jcb: 'J',
                    'master-card': 'M',
                    maestro: 'M',
                    visa: 'V',
                    unionpay: 'U'
                };
                var hasMatch = Object.prototype.hasOwnProperty.call(braintreeToInternalMapping, cardType);

                if (!hasMatch) {
                    return false;
                }

                return self.acceptedCards.indexOf(braintreeToInternalMapping[cardType]) > -1;
            }

            function handleFieldEvent(event, action) {
                var field = event.fields[event.emittedBy];

                if (!field) {
                    return;
                }

                var $container = $(field.container);
                var $parent = $container.parent();
                var target = event.emittedBy === 'number' ? $parent : $container;

                switch(action) {
                    case 'validity':
                        target.toggleClass('invalid', !field.isValid);
                        $parent.parent().find('label').toggleClass('invalid', !field.isValid);
                        break;
                    case 'blur':
                        target.removeClass('focused');
                        break;
                    case 'focus':
                        target.toggleClass('focused');
                        break;
                }
            }

            function onValidityChange(event) {
                handleFieldEvent(event, 'validity');  
            }

            function onBlur(event) {
                handleFieldEvent(event, 'blur');
            }

            function onFocus(event) {
                handleFieldEvent(event, 'focus');
            }

            function onBinAvailable(event){
                var $billingCCError = $('#billing_cc_error');
                if( $billingCCError.hasClass('hide') || $billingCCError.hasClass('hidden') ){
                SponsorEvents.sponsoredBin(event.bin)
                    .then(function(result) {
                        if (result.sponsor !== null){
                            if (!result.valid) {
                                var msg = window.FGTLibs.i18n.t(
                                    'Invalid card. Please enter a valid {{ eventName }} card to proceed.',
                                    { eventName: result.sponsor }
                                );
                                var errorMsg = "<i class='fa fa-exclamation-triangle fa-2x'></i><p>" + msg + "</p>";
                                $('#btn-billing-submit, #link-ppterms-modal-force').addClass('disabled');
                                $('#btn-billing-submit, #link-ppterms-modal-force').prop('disabled', true);
                                $('#billing_cc_error').removeClass('hidden').removeClass('hide').html(errorMsg);
                                if ($('#billing_cc_error').hasClass('invalid')) {
                                    $('#billing_cc_error').show();
                                }
                            } else {
                                if (result.error){
                                    customdialog('Ok', $('#credit-card-number'));
                                } else {
                                    $('#btn-billing-submit, #link-ppterms-modal-force').removeClass('disabled');
                                    $('#btn-billing-submit, #link-ppterms-modal-force').prop('disabled', false);
                                    $('#billing_cc_error').addClass('hidden').addClass('hide').html('');
                                }
                            }
                        }
                    });
                }
            }

            function customdialog(button1, element){
                var btns = {};
                btns[button1] = function(){
                    $(this).dialog("close");
                    location.reload();
                };
                $("<div>An error has occourred, please try again.</div>").dialog({
                    autoOpen: true,
                    title: 'Warning',
                    modal:true,
                    buttons:btns
                });
            }

            function onVenmoTokenize(payload) {
                self.paymentTracker.activePayment = FGTLibs.Payments.PaymentType.VENMO;
                $('#nonce').val(payload.nonce);
                _venmoUsername = payload.details.username;
                $('#venmoUsername').html(_venmoUsername);
                // Required backend parameter
                $('#doNotUseStoredCard').val('1');
                unhideBillingSubmitButton();
                // The PayPal tokenization callback called this. Using the same behavior for Venmo.
                $('div.cardonfile').addClass('nocardonfile').removeClass('cardonfile');
                $('#same-as-shipping-address').addClass('hide');

                var isUsingLayaway = $('#payment_form').find('input[name="paymentPlan_preference"]:checked').val() === 'payUsingSelectedPlan';
                var options = {
                    username: payload.details.username,
                    isUsingLayaway: isUsingLayaway,
                    renderTo: 'div-form-paid',
                };
                FGTLibs.UpdateCheckout.renderVenmoSuccessLayout(options);
            }

            function onPaypalTokenize(payload) {
                self.paymentTracker.activePayment = FGTLibs.Payments.PaymentType.PAYPAL;

                $('#nonce').val(payload.nonce);
                _paypalUserEmail = payload.details.email;
                displayPaypal();

                // Cache the paypal payload
                FGTLibs.PaypalUtil.storePaypalPayload(payload);

                // display paypal info
                var paypalBilling = payload.details.billingAddress,
                    paypalFirstName = payload.details.firstName,
                    paypalLastName = payload.details.lastName,
                    ppinfoHtml = paypalFirstName + ' ' + paypalLastName + '<br />' + _paypalUserEmail + '<br />';

                $('#div-form-paid').append('<input type="hidden" id="paypalEmail" name="paypalEmail" value="' + _paypalUserEmail +'">');
                $('#div-card-on-file').removeClass('googlePaySummary');
                $('#div-card-on-file').addClass('paypalSummary');
                $('#same-as-shipping-address').addClass('hide');

                ppinfoHtml += paypalBilling.line1 + '<br />';
                if (paypalBilling.line2) { ppinfoHtml += paypalBilling.line2 + '<br />'; }
                ppinfoHtml += paypalBilling.city + ', ' + paypalBilling.state + ' ' + paypalBilling.postalCode + '<br />';
                ppinfoHtml += paypalBilling.countryCode;

                $('#ppinfo-static').attr('data-paypalfirstname', paypalFirstName);
                $('#ppinfo-static').attr('data-paypallastname', paypalLastName);
                $('#ppinfo-static').attr('data-paypalcity', paypalBilling.city);
                $('#ppinfo-static').attr('data-paypalstate', paypalBilling.state);
                $('#ppinfo-static').attr('data-paypalzip', paypalBilling.postalCode);

                var paypalAddress = paypalBilling.line2 ? paypalBilling.line1 + ', ' + paypalBilling.line2 : paypalBilling.line1
                $('#ppinfo-static').attr('data-paypaladdress', paypalAddress);

                $('#ppinfo-static').attr('data-countrycode', paypalBilling.countryCode);

                $('#ppinfo-static').html(ppinfoHtml);

                $('div.cardonfile').addClass('nocardonfile').removeClass('cardonfile');

                // Make sure the billing phone container is visible
                $('div[name="billingPhone"]').removeClass('hide');
                var $phone = $('#billing_phone');
                if (!$phone.val()) {
                    // Set the contact phone number field to the Paypal phone number if the field is empty
                    $phone.val(FGTLibs.PaypalUtil.getPhoneNumber());
                }
                // Set the firstName/lastName fields to the Paypal firstName/lastName if the fields are empty
                var $firstName = $('#billing_firstName');
                var $lastName = $('#billing_lastName');
                if (!$firstName.val() || !$lastName.val()) {
                    $firstName.val(FGTLibs.PaypalUtil.getFirstName());
                    $lastName.val(FGTLibs.PaypalUtil.getLastName());
                }
            }

            function onGoogleTokenize(payload, paymentData){
                self.paymentTracker.activePayment = FGTLibs.Payments.PaymentType.GOOGLEPAY;
                $('#nonce').val(payload.nonce);
                _googlePayUserEmail = paymentData.email;
                displayGooglePay();
                FGTLibs.GooglePayUtil.storeGooglePayPayload(payload);
                FGTLibs.GooglePayUtil.storageGooglePayPaymentData(paymentData);

                var googlePayBilling = paymentData.paymentMethodData.info.billingAddress,
                    googlePayFullname = paymentData.paymentMethodData.info.billingAddress.name,
                    gpayinfoHtml = googlePayFullname + '<br />';
                gpayinfoHtml += paymentData.email + '<br />';
                $('#div-form-paid').append('<input type="hidden" id="googlePayEmail" name="googlePayEmail" value="'+paymentData.email+'">');
                $('#div-card-on-file').removeClass('paypalSummary');
                $('#div-card-on-file').addClass('googlePaySummary');
                $('#same-as-shipping-address').addClass('hide');
                gpayinfoHtml += googlePayBilling.address1 + '<br />';

                if (googlePayBilling.address2) { gpayinfoHtml += googlePayBilling.address2 + '<br />'; }
                if (googlePayBilling.address3) { gpayinfoHtml += googlePayBilling.address3 + '<br />'; }
                gpayinfoHtml += googlePayBilling.locality + ', ' + googlePayBilling.administrativeArea + ' ' + googlePayBilling.postalCode + '<br />';
                gpayinfoHtml += googlePayBilling.countryCode;

                $('#gpayinfo-static').attr('data-googlepayfirstname', googlePayFullname.split(' ').slice(0, -1).join(' ') );
                $('#gpayinfo-static').attr('data-googlepaylastname', googlePayFullname.split(' ').slice(-1).join(' '));
                $('#gpayinfo-static').attr('data-googlepaycity', googlePayBilling.locality);
                $('#gpayinfo-static').attr('data-googlepaystate', googlePayBilling.administrativeArea);
                $('#gpayinfo-static').attr('data-googlepayzip', googlePayBilling.postalCode);
                var googlePayAddress = googlePayBilling.address2 ? googlePayBilling.address1 + ', ' + googlePayBilling.address2 : googlePayBilling.address1;
                googlePayAddress = googlePayBilling.address3 ? googlePayAddress + ', ' + googlePayBilling.address3 : googlePayAddress;
                $('#gpayinfo-static').attr('data-googlepayaddress', googlePayAddress);

                $('#gpayinfo-static').attr('data-countrycode', googlePayBilling.countryCode);

                $('#gpayinfo-static').html(gpayinfoHtml);

                $('div.cardonfile').addClass('nocardonfile').removeClass('cardonfile');

                // Make sure the billing phone container is visible
                $('div[name="billingPhone"]').removeClass('hide');
                var $phone = $('#billing_phone');
                if (!$phone.val()) {
                    // Set the contact phone number field to the Paypal phone number if the field is empty
                    $phone.val(googlePayBilling.phoneNumber);
                }
                // Set the firstName/lastName fields to the Paypal firstName/lastName if the fields are empty
                var $firstName = $('#billing_firstName');
                var $lastName = $('#billing_lastName');
                if (!$firstName.val() || !$lastName.val()) {
                    $firstName.val(googlePayFullname.split(' ').slice(0, -2).join(' '));
                    $lastName.val(googlePayFullname.split(' ').slice(-1).join(' '));
                }
            }

            function onApplePayTokenize(payload) {
                resetResponseErrors();
                hideApplePayBillingError();
                // #msg-billing is cleared alongside the confirm banner because the
                // country dead-end below writes there, and nothing else on the page
                // clears it: FG.Utils.showError sets the message with no fadeOut,
                // resetResponseErrors() only hides the four phone-error divs, and
                // hideApplePayBillingError() is scoped to .order_confirmation_text.
                // Since that branch deliberately leaves the customer able to select
                // another method, a later successful purchase would otherwise leave
                // "we could not read the billing country" sitting on the payment step
                // next to a completed order.
                $('#msg-billing').hide();
                self.paymentTracker.activePayment = FGTLibs.Payments.PaymentType.APPLEPAY;
                $('#nonce').val(payload.nonce);

                // Inject applePayEmail hidden input for save_billing POST
                $('#applePayEmail').remove();
                $('<input>')
                    .attr({ type: 'hidden', id: 'applePayEmail', name: 'applePayEmail' })
                    .val(payload.applePayEmail || '')
                    .appendTo('#div-form-paid');

                // Store billing info from the Apple Pay sheet. The address arrives on
                // the authorization event's billingContact (forwarded by ApplePay.js),
                // never on the Braintree tokenize payload's `details`. The mapping itself
                // lives in libs/ so it is unit-testable — checkout.js is outside jest's
                // roots — leaving only DOM writes here.
                var $billingCountry = $('#billing_country');
                var billingFields = FGTLibs.ApplePayUtil.applePayBillingFields(
                    payload.applePayBillingContact,
                    payload.applePayShippingContact,
                    getOptionValues($billingCountry)
                );

                if (!billingFields.country) {
                    // Neither the ISO code nor the sheet's localized name matched an
                    // option, so save_billing would store an empty country and
                    // OrderValidator would throw its generic billing error instead.
                    // Nothing about the option list changes on a retry, so re-tapping
                    // Apple Pay would reach here again — hence the full handoff back to
                    // the card form rather than a "try again".
                    var appleBilling = payload.applePayBillingContact || {};
                    self.restorePaymentStepForApplePayDeadEnd(window.FGTLibs.i18n.t(
                        'We could not read the billing country from Apple Pay. Please choose a different payment method.'));
                    FGTLibs.Bugsnag.log(new Error('Apple Pay: no billing country option matched ('
                        + appleBilling.countryCode + ', ' + appleBilling.country + ')'));
                    return;
                }

                // Only filled when empty, matching onPaypalTokenize and
                // onGoogleTokenize. Apple's `name` billing field is not guaranteed to
                // come back populated, and overwriting an account holder's stored name
                // with an empty string would fail OrderValidator's required-name check
                // — after the sheet has closed on an authorized payment. Guarding here
                // rather than rejecting in the sheet because there is no in-sheet
                // remedy: Apple gives the customer no editable name row, so an
                // ApplePayError on `name` would be an unclearable loop.
                var $firstName = $('#billing_firstName');
                var $lastName = $('#billing_lastName');
                if (!$firstName.val() || !$lastName.val()) {
                    $firstName.val(billingFields.firstName);
                    $lastName.val(billingFields.lastName);
                }

                $('#billing_address').val(billingFields.address);
                $('#billing_address2').val(billingFields.address2);
                $('#billing_city').val(billingFields.city);
                $('#billing_zip').val(billingFields.zip);
                $('#billing_phone').val(billingFields.phone);

                // Read before the overwrite: this is the country
                // #billing_select_state's options were built for, and the state match
                // below is only meaningful when Apple's country agrees with it.
                var stateOptionsCountry = $billingCountry.val();
                $billingCountry.val(billingFields.country);

                // The serialized `state` param comes from #billing_select_state, whose
                // options were built for whatever country the page loaded with. Setting
                // #billing_country above does not fire `change`, so bindToBillingCountry
                // never rebuilds them, and triggering a rebuild here would race the
                // cart/billing_states request against the save_billing POST below.
                //
                // So the match is only attempted when Apple's country is the one those
                // options belong to. Subdivision codes are not globally unique — "CA"
                // is California in the US list and Cataluña in the Spanish one, "BC" is
                // British Columbia in Canada and Baja California in Mexico — so a
                // cross-country match writes a real-looking but wrong CONTACT.STATE,
                // which then feeds the Braintree region on an AVS check and Kount.
                // Passing '' clears the stale selection instead, leaving the state
                // empty, which is the same outcome as an unmatched subdivision below.
                //
                // Apple's administrativeArea is matched against both the option value
                // and the option text because the select carries {value: stateAbbr,
                // text: stateName}: the US and Canada return the abbreviation, but GB
                // returns a county name and Mexico commonly returns the full state
                // name. Matching text as well resolves those against the option list
                // itself, so no second source of truth is introduced.
                //
                // Nothing is appended when neither matches. A synthetic option would
                // post a value no other billing path can produce — CONTACT.STATE feeds
                // the Braintree region and is matched by DBOContact::isStateUSA()
                // against STATE_ABBR/STATE_NAME — and would render in the dropdown as
                // the raw string next to properly-labelled options. An unmatched
                // subdivision therefore persists as an *empty* state, which is the
                // better outcome: OrderValidator only requires a state on the Venmo
                // branch, so nothing is blocked.
                //
                // #billing_state_other posts as `xstate`, which save_billing never
                // reads (it reads `state`), so the value below reaches no contact
                // record — the only reader of xstate anywhere is UserHandler.php:298.
                // It is written for consistency with the other billing paths. The
                // readers on this page (the #btn-insurance-no handler below,
                // accordion2.twig and renderVenmoSuccessLayout.js) pick between two GTM
                // analytics labels or seed the Venmo form; the first two test
                // `val() == 'XX'`, which Apple never returns as an administrativeArea,
                // and the third is not reachable from the Apple Pay path.
                var stateOptionsUsable = stateOptionsCountry === billingFields.country;
                var stateMatched = selectMatchingOption(
                    $('#billing_select_state'),
                    stateOptionsUsable ? billingFields.state : '');
                $('#billing_state_other').val(billingFields.state);

                // Logged rather than surfaced: an empty state blocks nothing, but it is
                // the only silent data loss left on this path, so how often Apple
                // returns a subdivision the select cannot express is worth knowing. The
                // country pair is in the message so a mismatch (options built for one
                // country, Apple reporting another) is distinguishable from a genuine
                // gap in the COUNTRY_STATE rows for the right country.
                if (billingFields.state && !stateMatched) {
                    FGTLibs.Bugsnag.log(new Error(
                        'Apple Pay: billing state matched no option ('
                        + billingFields.state + ', ' + billingFields.country
                        + ', options built for ' + stateOptionsCountry + ')'));
                }

                // No completeness check here: ApplePay.js rejects an incomplete contact
                // inside onpaymentauthorized, so this callback only ever runs with a
                // usable address. Guarding here would be too late — the sheet has
                // already reported success and closed by the time this runs.

                // The Apple Pay sheet opens on the confirm step, after save_billing has
                // already run with empty billing fields. JobSessionPurchase only validates
                // the stored billing contact, it never writes it — so the address has to be
                // persisted through save_billing before the purchase is submitted.
                //
                // Nothing is done here about session currentStep, which this second
                // save_billing also rewrites: JobSessionSaveBilling:286 recognizes the
                // Apple Pay caller and leaves it on 'confirm' rather than rewinding it to
                // the insurance step this POST has already passed. Fixed there rather
                // than with a follow-up request from here because a POST is another
                // failure point on an authorized payment, and only the job can tell
                // which step its caller came from.
                // Returned so ApplePay.js's sessionActive guard spans the POST. Without
                // it the guard clears as soon as this function returns, leaving the
                // button clickable for one POST — long enough on a slow connection for
                // a second tap to overwrite #nonce and submit the order twice.
                return postApplePayBilling()
                    .then(function() {
                        $('#confirm_form').submit();
                    })
                    .catch(function(err) {
                        // err.message is never shown to the customer, only branched on.
                        // API.post rejects with Error(body.msg) and save_billing puts
                        // internal tokens in msg — 'invalid_layaway_plan' on the bad-plan
                        // early return, $e->getMessage() in the catch-all — so rendering
                        // it would leak server internals. The real text goes to Bugsnag.
                        FGTLibs.Bugsnag.log(err instanceof Error
                            ? err
                            : new Error('Apple Pay save_billing failed: ' + err));

                        // The bad-plan rejection (CheckoutHandler.php:1129) is
                        // deterministic: postToSaveBilling's early return does not change
                        // on a retry, so "try again" would loop the customer forever.
                        // Handled the way submitCard() handles the same rejection (line
                        // 1673) — surface the plan error and collapse the payment form so
                        // the plan selector is the only thing to act on — rather than with
                        // restorePaymentStepForApplePayDeadEnd(), which opens the card
                        // form: the remedy here is a different plan, not a different
                        // payment method, and the existing plan is still what needs
                        // replacing. The Apple Pay button and activePayment are reset
                        // anyway, so re-selecting a plan re-enters payment selection
                        // cleanly instead of down the Apple Pay branch with a dead nonce.
                        if (err && err.message === 'invalid_layaway_plan') {
                            $('#nonce').val('');
                            self.toggleApplePayButtonVisibility(false);
                            self.paymentTracker.activePayment =
                                FGTLibs.Payments.PaymentType.CARD;
                            self.makeStepActive('collapseTwo');
                            $('.selectPaymentPlan #paymentPlanErrorMessage').removeClass('hide');
                            $('#paymentPlanId')
                                .removeClass('border')
                                .addClass('border-danger')
                                .attr('aria-describedby', 'paymentPlanErrorMessage');
                            $('a.link-ppterms-modal').hide();
                            $('#paymentMethods, #div-form-paid').addClass('hide');
                            $('#paymentPlans').css('padding-bottom', '0');
                            $('.payment-schedule__container').addClass('hide');
                            return;
                        }

                        // Everything else is treated as transient and retried in place.
                        // #nonce is cleared for the same reason as the country dead-end:
                        // the billing contact was not persisted, so purchasing against
                        // this nonce would submit the order with whatever address
                        // save_billing last stored — on this path the empty one the
                        // confirm step was reached with. "Try again" means re-tapping
                        // Apple Pay, which mints a fresh nonce, so nothing is lost by
                        // dropping this one.
                        $('#nonce').val('');
                        showApplePayBillingError(window.FGTLibs.i18n.t(
                            'We could not save your Apple Pay billing address. Please try again.'));
                    });
            }

            /**
             * Collect the option values of a <select>.
             *
             * Thin wrapper over the ApplePayUtil implementation, which lives in libs/
             * so it can be unit-tested — checkout.js is outside jest's roots. The
             * unwrapping here rather than at each call site keeps the boundary in one
             * place: libs/ takes the DOM element, not a jQuery object, because it
             * bundles its own jQuery and passing a wrapper across would mean two
             * instances in one call.
             *
             * @param {jQuery} $select
             * @returns {Array<string>}
             */
            function getOptionValues($select) {
                return FGTLibs.ApplePayUtil.getOptionValues($select.get(0));
            }

            /**
             * Select the option matching `value` by either its value or its visible
             * text, and clear the selection when neither matches. See
             * ApplePayUtil/applePaySelectOptions.js for the state-select rules the
             * match encodes and why no option is ever appended.
             *
             * The lookup is there and the write is here: libs/ stays read-only over
             * the element so it does not have to touch this page's jQuery.
             *
             * @param {jQuery} $select
             * @param {string} value
             * @returns {boolean} true when an option matched
             */
            function selectMatchingOption($select, value) {
                var matched = FGTLibs.ApplePayUtil.findMatchingOptionValue(
                    $select.get(0), value);
                $select.val(matched === null ? '' : matched);
                return matched !== null;
            }

            /**
             * Render a save_billing failure on the confirm step. Only reachable after
             * the sheet has closed on an authorized payment, so the message has to
             * surface on the page — an incomplete contact is rejected earlier, inside
             * the sheet itself (see ApplePay.js onpaymentauthorized).
             *
             * alert-error, not alert-danger: core-styles.css only themes alert-success,
             * alert-error and alert-warning, and FG.Utils.showError() sets alert-error.
             *
             * APPLEPAY_BILLING_ERROR_CLASS carries no styling — it exists only so
             * hideApplePayBillingError() can tell our message apart from the other
             * consumers of this shared banner. alert-error cannot serve that purpose:
             * the purchase request and the InvalidLayawayPlanException branch set it
             * too, so keying the reset on it would wipe their messages.
             * @param {string} message
             */
            function showApplePayBillingError(message) {
                $('.order_confirmation_text')
                    .removeClass('hide alert-success')
                    .addClass('alert-error ' + APPLEPAY_BILLING_ERROR_CLASS)
                    .html(message)
                    .show();
            }

            /**
             * Clear a previous Apple Pay billing error, which purchaseTickets() would
             * otherwise leave as an empty red bar on retry.
             *
             * This banner is shared: it is the message target for the purchase request
             * itself (Ajax.setMessageDiv('.order_confirmation_text')) and for the
             * InvalidLayawayPlanException branch. So the reset is scoped to the case
             * where the banner is actually carrying our own error — otherwise another
             * consumer's message would be wiped on every Apple Pay tap. Scoped by our
             * own marker class rather than by alert-error, which those other consumers
             * also set.
             *
             * alert-success is restored because the template declares this element as
             * `alert alert-success hide` (confirm.twig); without it the element would be
             * left with no variant class and the next message would render unstyled.
             *
             * Visibility is undone with .hide() rather than by re-adding the `hide`
             * class, but only as a matter of symmetry with showApplePayBillingError's
             * removeClass('hide') — not because re-adding it would break anything.
             * Both work: the existing consumers reveal this banner with slideDown()
             * and .show(), which set an inline display that cannot beat the !important
             * in Bootstrap's .hide{display:none!important}, but the purchase failure
             * callback does its own removeClass('hide') first (line 3746) and Ajax runs
             * that callback before error() (ajax.js:225-230), so the class is already
             * gone before the slideDown. Thanks to @adam.bodnar for checking this; an
             * earlier version of this comment claimed the class would stick.
             *
             * The live tradeoff is the mirror image, and it is the reason to read this
             * before adding a consumer: the banner is left carrying an inline
             * display:none and no `hide` class, so a future consumer that reveals it
             * with removeClass('hide') alone would find it still hidden.
             */
            function hideApplePayBillingError() {
                var $banner = $('.order_confirmation_text');

                if (!$banner.hasClass(APPLEPAY_BILLING_ERROR_CLASS)) {
                    return;
                }

                $banner
                    .removeClass('alert-error ' + APPLEPAY_BILLING_ERROR_CLASS)
                    .addClass('alert-success')
                    .html('')
                    .hide();
            }

            /**
             * Post the billing form for an Apple Pay payment, normalizing the phone
             * first. Used by the confirm-step caller — onApplePayTokenize, which has
             * just written the raw Wallet number into #billing_phone.
             *
             * The util/validate round-trip is the same one the card and free paths
             * make, so what gets stored is the E.164 number SMSUtil produces rather
             * than whatever national format Wallet returned.
             *
             * Not shared with submitApplePay(): that caller posts a #billing_phone
             * that either came from the stored contact — already normalized, by
             * DBOContact::setPhone() when it was saved — or was normalized here on a
             * previous tap. Re-validating it spends a network round-trip on the
             * critical path to confirm a value that cannot have changed, and every
             * such call is another chance for the util/validate failure this
             * function deliberately swallows.
             * @returns {Promise}
             */
            function postApplePayBilling() {
                return normalizeApplePayPhone().then(postApplePayBillingForm);
            }

            /**
             * Normalize #billing_phone through util/validate, as the card and free
             * paths do, so a Wallet number in national format is stored in the same
             * E.164 form as every other billing path produces.
             *
             * Never rejects. Unlike the card path — which is pre-purchase and can show
             * the customer a phone error — this runs after the sheet has closed on an
             * authorized payment, so failing here would strand an authorized order. The
             * raw number is posted instead: ApplePay.js already rejected anything
             * save_billing would refuse (persistablePhone.js), and DBOContact::setPhone()
             * does the authoritative normalization server-side regardless.
             * @returns {Promise}
             */
            function normalizeApplePayPhone() {
                var $phone = $('#billing_phone');
                var phoneNumber = ($phone.val() || '').trim();

                if (!phoneNumber) {
                    return Promise.resolve();
                }

                return FGTLibs.API.post({
                    path: 'util/validate',
                    parameters: { phone: phoneNumber },
                    wait: 0,
                }).then(function(result) {
                    if (result && result.valid && result.phone_number) {
                        $phone.val(result.phone_number);
                    }
                }).catch(function(err) {
                    // Logged, not surfaced: the raw number still posts.
                    FGTLibs.Bugsnag.log(err instanceof Error
                        ? err
                        : new Error('Apple Pay phone validation failed: ' + err));
                });
            }

            /**
             * Serialize and POST #payment_form to save_billing for an Apple Pay
             * payment. Serializes the whole form so the layaway params
             * (paymentPlan_preference, paymentPlanId) and the CSRF token that
             * save_billing requires are included.
             *
             * Shared by both Apple Pay save_billing callers so the payload stays in
             * one place; only the confirm-step caller wraps it in
             * postApplePayBilling() to normalize the phone first. Callers own their
             * own side effects — notably, the confirm-step caller must NOT hand the
             * response to saveBillingComplete(), whose window.location.reload()
             * branch would discard the just-tokenized nonce.
             * @returns {Promise}
             */
            function postApplePayBillingForm() {
                $('#billing_ccType').val('ApplePay');

                // Serializing #payment_form also posts #doNotUseStoredCard, and
                // save_billing deletes the session flag when the value is empty or
                // negative (CheckoutHandler::postToSaveBilling). displayApplePay() sets
                // it to 1, but the #after_payment_refresh path selects Apple Pay without
                // going through that function, leaving the template's default of -1. That
                // would clear a flag the payment step had already set and send the Apple
                // Pay nonce into verifyVaultedCard() against the vaulted card's token.
                // Set it here so both callers post the same value.
                $('#doNotUseStoredCard').val('1');

                var params = $('#payment_form').serialize() + '&csrf_token=' + encodeURIComponent(CSRF_TOKEN);

                return FGTLibs.API.post({
                    path: 'checkout/save_billing',
                    parameters: params,
                    wait: 0,
                });
            }

            function freeValidateHandler() {
                if (!self.billingValidator.checkAll().pass){
                    return false;
                }

                resetResponseErrors();

                self.laddaBtnBillingSubmit.start();
                var billingCountryCode = FG.Utils.getCountryCode("#phone-intl-billing");
                var phoneNumber = $('#billing-intl-phone-input').val().trim();

                if (!billingCountryCode.length || !phoneNumber.length ) {
                    $('#phone-intl-billing input[type="tel"]').addClass('invalid');
                    $('#missing_billing_phone_error_free').removeClass('hidden');
                    $('#billing_phone_free_error').addClass('hidden');
                    return;
                }

                var validatePhoneOptions = {
                    path: 'util/validate',
                    parameters: { phone: billingCountryCode + phoneNumber },
                    wait: 0,
                };

                FGTLibs.API.post(validatePhoneOptions)
                    .then(function(result) {
                        if (result && !result.valid) {
                            throw Error('server_invalid_phone');
                        }
                        $('#billing_phone_free').val(result.phone_number);

                        var saveOptions = {
                            path: 'checkout/save_billing',
                            parameters: $('#div-form-free').find('input, select').serialize() + '&csrf_token=' + encodeURIComponent(CSRF_TOKEN),
                            wait: 0,
                        };
                        return FGTLibs.API.post(saveOptions);
                    })
                    .then(function(result) {
                        saveBillingComplete(result);
                        self.laddaBtnBillingSubmit.stop();
                        $("#acc-step-two-b li>a.accordion-toggle").trigger('focus');
                    })
                    .catch(function(error) {
                        self.laddaBtnBillingSubmit.stop();

                        if (error.message === 'server_invalid_phone') {
                            $('#phone-intl-billing input[type="tel"]').addClass('invalid');
                            $('#missing_billing_phone_error_free').addClass('hidden');
                            $('#billing_phone_free_error').removeClass('hidden');
                            return;
                        }
                        window.location.reload();
                    });
            }

            function validateHandler() {
                var paymentTracker = self.paymentTracker;
                if (paymentTracker && paymentTracker.activePayment === PaymentType.VENMO) {
                    if (window.venmoSuccess) {
                        window.venmoSuccess.formRef.current.handleSubmit();
                        window.venmoCb = function (data) {
                            $('#billing_firstName').val(data.firstName);
                            $('#billing_lastName').val(data.lastName);

                            var extra = Object.keys(data).map(function (key) {
                                return { name: key, value: data[key] };
                            });

                            submitVenmo(extra);
                        };
                    }
                    return true;
                }

                if (paymentTracker && paymentTracker.activePayment === PaymentType.PAYPAL) {
                    var config = [
                        { id: 'billing-intl-phone-input', type: ['required', 'noHTML'] }
                    ];
                    self.setupBillingValidator(config);
                    if (!self.billingValidator.checkAll().pass){
                        return false;
                    }
                    submitPaypal();
                    return true;
                }

                if (paymentTracker && paymentTracker.activePayment === PaymentType.GOOGLEPAY){
                    var config = [
                        { id: 'billing-intl-phone-input', type: ['required', 'noHTML'] }
                    ];
                    self.setupBillingValidator(config);
                    if (!self.billingValidator.checkAll().pass){
                        return false;
                    }
                    submitGooglePay();
                    return true;
                }

                if (paymentTracker && paymentTracker.activePayment === PaymentType.APPLEPAY){
                    submitApplePay();
                    return true;
                }


                var config = [
                    { id: 'billing_firstName', type: ['required', 'noHTML'] },
                    { id: 'billing_lastName', type: ['required', 'noHTML'] },
                    { id: 'billing-intl-phone-input', type: ['required', 'noHTML'] },
                    { id: 'billing_address', type: ['required', 'noHTML'] },
                    { id: 'billing_address2', type: ['noHTML'] },
                    { id: 'billing_city', type: ['required', 'noHTML'] },
                    { id: 'billing_zip', type: ['required', 'noHTML'] },
                ];
                self.setupBillingValidator(config);

                if (!self.billingValidator.checkAll().pass){
                    $("#div-form-paid .error-msg.invalid:first").parent().find("input").focus();
                    return false;
                }

                var country = $('#billing_country').val();
                var $billingSelectState = $('#billing_select_state');
                if (MY_COUNTRIES_ARRAY.indexOf(country) > -1) {
                    var state = $billingSelectState.val();
                    if (self.isValueValid(state)) {
                        $('#billing_state_label, #billing_select_state').removeClass('invalid');
                    } else {
                        $('#billing_state_label, #billing_select_state').addClass('invalid');
                        $billingSelectState.addClass('invalid').focus();
                        return false;
                    }
                }

                submitCard();
            }

            function resetResponseErrors() {
                $('#billing_phone_error, #billing_phone_free_error ,#missing_billing_phone_error,#missing_billing_phone_error_free').addClass('hidden');
            }

            function submitVenmo(extra) {
                self.laddaBtnBillingSubmit.start();
                $('#venmo-phone-label').removeClass('error')
                $('#venmo-phone-field input[type="tel"]').removeClass('invalid');
                $('#venmo-phone-error').addClass('hidden');

                var billingCountryCode = FG.Utils.getCountryCode("#venmo-phone-field");
                var phoneNumber = $('#venmo-intl-phone-input').val().trim();

                var validatePhoneOptions = {
                    path: 'util/validate',
                    parameters: { phone: billingCountryCode + phoneNumber },
                    wait: 0,
                };
                FGTLibs.API.post(validatePhoneOptions)
                    .then(function(result) {
                        if (result && !result.valid) {
                            throw Error('server_invalid_phone');
                        }

                        extra.push({ 
                            name: 'phone',
                            value: result.phone_number
                        });

                        var venmoPayloadConfig = {
                            formId: '#payment_form',
                            filterKeys: [
                                'paymentPlanId',
                                'paymentPlan_preference',
                                'currentStoredCardType',
                                'doNotUseStoredCard',
                            ],
                            extra: extra,
                        };
                        var params = self.braintreeAPI.venmoInstance.getSerializedPayload(venmoPayloadConfig) + '&csrf_token=' + encodeURIComponent(CSRF_TOKEN);
                        var options = {
                            path: 'checkout/save_billing',
                            parameters: params,
                            wait: 0,
                        };
                        return FGTLibs.API.post(options)
                    })
                    .then(function(response) {
                        saveBillingComplete(response);
                        self.laddaBtnBillingSubmit.stop();
                    })
                    .catch(function(error) {
                        self.laddaBtnBillingSubmit.stop();
                        if (error.message === 'server_invalid_phone') {
                            $('#venmo-phone-label').addClass('error')
                            $('#venmo-phone-field input[type="tel"]').addClass('invalid');
                            $('#venmo-phone-error').removeClass('hidden');
                            return;
                        }
                        FGTLibs.Bugsnag.log(error);
                        window.location.reload();
                    });
            }

            function submitPaypal() {
                resetResponseErrors();
                self.laddaBtnBillingSubmit.start();

                var billingCountryCode = FG.Utils.getCountryCode("#phone-intl-billing");
                var phoneNumber = $('#billing-intl-phone-input').val().trim();

                var validatePhoneOptions = {
                    path: 'util/validate',
                    parameters: { phone: billingCountryCode + phoneNumber },
                    wait: 0,
                };
                FGTLibs.API.post(validatePhoneOptions)
                    .then(function(result) {
                        if (result && !result.valid) {
                            throw Error('server_invalid_phone');
                        }

                        $('#billing_phone').val(result.phone_number);

                        var params = FGTLibs.PaypalUtil.serializeWithPaypal('#payment_form', $) + '&csrf_token=' + encodeURIComponent(CSRF_TOKEN);
                        var options = {
                            path: 'checkout/save_billing',
                            parameters: params,
                            wait: 0,
                        };
                        return FGTLibs.API.post(options);
                    })
                    .then(function(response) {
                        saveBillingComplete(response);
                        self.laddaBtnBillingSubmit.stop();
                    })
                    .catch(function(error) {
                        self.laddaBtnBillingSubmit.stop();

                        if (error.message === 'server_invalid_phone') {
                            $('#billing_phone_error').removeClass('hidden');
                            $('#phone-intl-billing input[type="tel"]').addClass('invalid');
                            $('#missing_billing_phone_error').addClass('hidden');
                            return;
                        }

                        window.location.reload();
                    });
            }

            function submitGooglePay(){
                resetResponseErrors();
                self.laddaBtnBillingSubmit.start();

                var billingCountryCode = FG.Utils.getCountryCode("#phone-intl-billing");
                var phoneNumber = $('#billing-intl-phone-input').val().trim();

                var validatePhoneOptions = {
                    path: 'util/validate',
                    parameters: { phone: billingCountryCode + phoneNumber },
                    wait: 0,
                };

                FGTLibs.API.post(validatePhoneOptions)
                    .then(function(result) {
                        if (result && !result.valid) {
                            throw Error('server_invalid_phone');
                        }

                        $('#billing_phone').val(result.phone_number);
                        var params = FGTLibs.GooglePayUtil.serializeWithGooglePay('#payment_form', $) + '&csrf_token=' + encodeURIComponent(CSRF_TOKEN);
                        var options = {
                            path: 'checkout/save_billing',
                            parameters: params,
                            wait: 0,
                        };
                        return FGTLibs.API.post(options);
                    })
                     .then(function(response) {
                         saveBillingComplete(response);
                         self.laddaBtnBillingSubmit.stop();
                     })
                    .catch(function(error) {
                        self.laddaBtnBillingSubmit.stop();

                        if (error.message === 'server_invalid_phone') {
                            $('#billing_phone_error').removeClass('hidden');
                            $('#phone-intl-billing input[type="tel"]').addClass('invalid');
                            $('#missing_billing_phone_error').addClass('hidden');
                            return;
                        }
                        window.location.reload();
                    });

            }

            function submitApplePay() {
                resetResponseErrors();
                self.laddaBtnBillingSubmit.start();

                // postApplePayBillingForm() rather than postApplePayBilling(): the
                // phone in the form here is already in its normalized form, so the
                // util/validate round-trip that wrapper adds would only spend time on
                // the critical path. See postApplePayBilling().
                postApplePayBillingForm()
                    .then(function(response) {
                        saveBillingComplete(response);
                        self.laddaBtnBillingSubmit.stop();
                    })
                    .catch(function() {
                        self.laddaBtnBillingSubmit.stop();
                        window.location.reload();
                    });
            }

            function submitCard() {
                resetResponseErrors();
                self.laddaBtnBillingSubmit.start();
                var $doNotUseStoredCard = $('#doNotUseStoredCard');
                var $paymentForm = $('#payment_form');

                var tokenOptions;
                if ($doNotUseStoredCard.val() === '0') {
                    // This means the customer is purchasing with their stored card
                    // only tokenize the cvv
                    tokenOptions = {
                        fieldsToTokenize: ['cvv'],
                    };
                } else {
                    // This means the customer has entered a card
                    // Tokenize all hosted fields (default behavior) and pass in the billing zip for AVS
                    tokenOptions = {
                        billingAddress: {
                            postalCode: $('#billing_zip').val() || '',
                        },
                    };
                }

                $('#billing_ccType').val('Unknown');
                for (var key in MY_BILLING_TYPES_ARRAY) {
                    if ($('#billing_ccType').parent().hasClass(key)){
                        $('#billing_ccType').val(MY_BILLING_TYPES_ARRAY[key]);
                    }
                }

                for (var i = 0; i < MY_SUBMIT_DATA_ARRAY.length; i++) {
                    FG['SubmitData']['billing_' + MY_SUBMIT_DATA_ARRAY[i]] = $paymentForm.find('input[name="' + MY_SUBMIT_DATA_ARRAY[i] + '"]').val();
                }
                FG.SubmitData.billing_ccSave = $paymentForm.find('input[name="billing_ccSave"]').is(':checked');

                var billingCountryCode = FG.Utils.getCountryCode("#phone-intl-billing");
                var phoneNumber = $('#billing-intl-phone-input').val().trim();

                if (!billingCountryCode.length || !phoneNumber.length ) {
                    $('#phone-intl-billing input[type="tel"]').addClass('invalid');
                    $('#missing_billing_phone_error').removeClass('hidden');
                    $('#billing_phone_error').addClass('hidden');
                    return;
                }

                var validatePhoneOptions = {
                    path: 'util/validate',
                    parameters: { phone: billingCountryCode + phoneNumber },
                    wait: 0,
                };
                FGTLibs.API.post(validatePhoneOptions)
                    .then(function(result) {
                        if (result && !result.valid) {
                            throw Error('server_invalid_phone');
                        }

                        $('#billing_phone').val(result.phone_number);
                        return self.braintreeAPI.tokenizeHostedFields(tokenOptions);
                    })
                    .then(function(payload) {
                        if (self.isThreeDSecureEnabled) {
                            var storedCardNonce = $('#three_d_nonce').val() || '';
                            // If bin is empty then a stored card must have been used
                            // Use stored card nonce provided by the backend
                            // Fallback to payload nonce if stored card nonce is empty
                            var nonce = (payload.details.bin.length === 0 && storedCardNonce.length) ? storedCardNonce : payload.nonce;
                            var cardBin = payload.details.bin.length !== 0 ? payload.details.bin : $('#card_bin').val();

                            self.braintreeAPI.updateNonceBin({
                                nonce: nonce,
                                bin: cardBin,
                            });
                        }

                        var mask = payload.details.bin + '******' + payload.details.lastFour;

                        self.paymentTracker.activePayment = FGTLibs.Payments.PaymentType.CARD;
                        $('#nonce').val(payload.nonce);
                        $('#mask').val(mask);
                        $('#billing_ccType').val(payload.details.cardType);
                        var options = {
                            path: 'checkout/save_billing',
                            parameters: $('#payment_form').serialize() + '&csrf_token=' + encodeURIComponent(CSRF_TOKEN),
                            wait: 0,
                        };
                        return FGTLibs.API.post(options);
                    })
                    .then(function (response) {
                        removeAttributes("#div-form-paid #btn-billing-submit");
                        saveBillingComplete(response);
                        self.laddaBtnBillingSubmit.stop();
                        $("#acc-step-two-b li>a.accordion-toggle").focus();
                    })
                    .catch(function (error) {
                        removeAttributes("#div-form-paid #btn-billing-submit");
                        var cardErrorMsg = '';
                        $("#div-form-paid #billing_cc_error").removeAttr("aria-live").find('span').remove();
                        self.laddaBtnBillingSubmit.stop();

                        if (error.message === 'server_invalid_phone') {
                            $('#phone-intl-billing input[type="tel"]').addClass('invalid');
                            $('#missing_billing_phone_error').addClass('hidden');
                            $('#billing_phone_error').removeClass('hidden');
                        } else if (error.name === 'BraintreeError') {
                            cardErrorMsg = "<span>Invalid card details</span>";
                            $("#div-form-paid #billing_cc_error").html(cardErrorMsg).attr("aria-live", "polite").css("display", "none");
                            $("#div-form-paid #btn-billing-submit").attr("aria-labelledby", "billing_cc_error").attr("aria-describedby", "billing_cc_error");
                            switch (error.code) {
                                case 'HOSTED_FIELDS_FIELDS_EMPTY':
                                    $('.braintree-field-wrapper').addClass('invalid');
                                    if (
                                        self.braintreeAPI &&
                                        self.braintreeAPI.hostedFieldsInstance &&
                                        self.braintreeAPI.hostedFieldsInstance.instance
                                    ) {
                                        self.braintreeAPI.hostedFieldsInstance.instance.focus('number');
                                    }
                                    break;
                                case 'HOSTED_FIELDS_FIELDS_INVALID':
                                    error.details.invalidFieldKeys.forEach(function(name) {
                                        error.details.invalidFields[name].classList.add('invalid');
                                    });
                                    break;
                                default:
                                    FGTLibs.Bugsnag.logBraintree('_hostedfields', error);
                                    break;
                            }
                        } else if (error.message === 'invalid_layaway_plan') {
                            $('.selectPaymentPlan #paymentPlanErrorMessage').removeClass('hide');
                            $('#paymentPlanId').removeClass('border').addClass('border-danger').attr('aria-describedby', 'paymentPlanErrorMessage');
                            $('a.link-ppterms-modal').hide();
                            $('#paymentMethods,#div-form-paid').addClass('hide');
                            $('#paymentPlans').css('padding-bottom', '0');
                            $('.payment-schedule__container').addClass('hide');
                        } else {
                            // some other error, just reload
                            window.location.reload();
                        }
                    });
            }

            function removeAttributes(el) {
                var $el = $(el);
                if ($el.attr("aria-describedby")) {
                    $el.removeAttr("aria-describedby");
                }
                if ($el.attr("aria-labelledby")) {
                    $el.removeAttr("aria-labelledby");
                }
            }

            function saveBillingComplete(FGResponse) {
                // If the payment plan is selected, we need to remove the promo code
                var $selectedPlanId = $('#selectedPaymentPlanId');
                var $talonOneCode = $('#isTalonOnePromoApplied');
                var $invalidPromoCode = $('#invalidPromoCode');
                if (
                    $selectedPlanId.length && $selectedPlanId.val() &&
                    $talonOneCode.length && $talonOneCode.val() &&
                    $invalidPromoCode.length && !$invalidPromoCode.val()
                ) {
                    window.location.reload();
                }
                var paymentTracker = self.paymentTracker;
                if($("#AllianzProv").val() === "Allianz"){
                    Allianz.resetAllianzInsuranceMessages();

                    if(paymentTracker && paymentTracker.activePayment === PaymentType.VENMO) {
                        Allianz.renderWithoutAllianz.call(self);
                    } else if(paymentTracker && paymentTracker.activePayment === PaymentType.GOOGLEPAY){
                        $("#insuranceAllianzAcceptedText").addClass('hide');
                        $("#insurance_unavailable").removeClass('hide');
                        AllianzError.allianzNotAvailable();
                    }
                    // Check the Billing Country of the PayPal or Card, if not US skip the request to Allianz
                    else if(Allianz.getBillingCountry(self.paymentTracker.activePayment) === 'United States' && Allianz.allowBillingState(self.paymentTracker.activePayment)) {
                        Allianz.getQuote.call(self, self.paymentTracker.activePayment);
                    } else {
                        $("#insuranceAllianzAcceptedText").addClass('hide');
                        $("#insurance_unavailable").removeClass('hide');
                        AllianzError.allianzNotAvailable();
                    }
                }

                //Google Tag Manager
                var layaway = $('#payment_plan_payUsingSelected').is(':checked');
                if (layaway || $('#payment_plan_payInFull').is(':checked')) {
                    // layaway or Pay Now?
                    var paymentOption = layaway ? 'Layaway - ' + $('#paymentPlanId option:selected').text().trim() : 'Pay Now';
                    self.sendStepAndActionToECommerce('Payment Method', paymentOption);
                }

                //Show an updated summary before the accordion closes
                $('#div-summary-billing').slideDown('slow',function () {
                    $(this).html(FGResponse.data.summary);

                    if(FGResponse.data.ccType !== 'Venmo') {
                        $("#venmoUsername").hide();
                    }

                    if(paymentTracker.activePayment !== PaymentType.GOOGLEPAY){
                        $("#googlePayUserEmail").hide();
                    }
                    if (paymentTracker.activePayment !== PaymentType.PAYPAL) {
                        $("#paypalUserEmail").hide();
                    }
                    $("#paypalUserEmail").html(_paypalUserEmail);
                    $("#googlePayUserEmail").html(_googlePayUserEmail);
                    $("#venmoUsername").html(_venmoUsername);
                }).parent().parent().parent().parent().addClass('complete');

                //Add payment plan table, if applicable.
                var $divPaymentPlanTable = $('#div-payment-plan-table');
                if ($divPaymentPlanTable.length > 0) {
                    $divPaymentPlanTable.html(FGResponse.data.paymentPlan);
                }

                //Update insurance cost
                $('#span-cost-insurance').html(FGResponse.data.insuranceCost);

                if ($('#btn-insurance-yes').val() == undefined){
                    null;
                } else {
                    $('#btn-insurance-yes').val("Add Secure Ticket™ for " + FGResponse.data.insuranceCost);
                }

                //Update the order summary screen as payment plan might have updated totals
                $('#order_summary_fragment').html(FGResponse.data.orderSummary);

                $("#paypalPayLaterMsg").addClass('hide');
                //Make the expand links work, in order summary
                FG.Checkout.prototype.bindToOrderSummaryDetails();

                self.toggleStoredCardBlock(FGResponse); // layaway plan or save card?

                // Handle Apple Pay button display
                if (paymentTracker && paymentTracker.activePayment === PaymentType.APPLEPAY) {
                    // activePayment can be APPLEPAY off Safari: #after_payment_refresh seeds it
                    // from the server-persisted ccType (chosen on an iPhone, resumed elsewhere),
                    // so the helper checks live availability and element readiness first.
                    self.showApplePayButtonWhenUsable(function() {
                        // Re-init only with no live instance and no init in flight: the wrapper is
                        // truthy even after a failed create(), so guard on .instance; the
                        // in-flight guard stops double-init when two refresh responses race.
                        var applePayWrapper = self.braintreeAPI.applePayInstance;
                        if (!applePayWrapper || !applePayWrapper.instance) {
                            if (!self.braintreeAPI.applePayInitInFlight) {
                                self.braintreeAPI.applePayInitInFlight = self.braintreeAPI.applePay().then(function(result) {
                                    self.braintreeAPI.applePayInitInFlight = null;
                                    if (result === false) {
                                        // Init failed (logged to Bugsnag in ApplePay.create); hide
                                        // the button and restore the regular purchase button so the
                                        // user can still complete checkout.
                                        self.toggleApplePayButtonVisibility(false);
                                    }
                                }).catch(function(err) {
                                    self.braintreeAPI.applePayInitInFlight = null;
                                    FGTLibs.Bugsnag.log(err);
                                    self.toggleApplePayButtonVisibility(false);
                                });
                            }
                        }
                    });
                } else {
                    self.toggleApplePayButtonVisibility(false);
                }

                //Collapse the accordion
                FG.Checkout.prototype.makeStepActive('collapseThree');
            }
        },

        setOrderPayInFull: function () {
            var options = {
                path: 'checkout/set_order_pay_in_full',
                parameters: { csrf_token: CSRF_TOKEN },
                wait: 0,
            };
            FGTLibs.API.post(options).then(function (result) {
                $('#order_summary_fragment').html(result.data.orderSummary);
                FG.Checkout.prototype.bindToOrderSummaryDetails();
            });
        },

        // If we have a layaway plan set or if the user indicated they want to save their credit card
        toggleStoredCardBlock: function (FGResponse) {
            $('#storedcards_terms_block').toggleClass('hide',
                !(FGResponse.data.ccSave == 1 || (FGResponse.data.paymentPlanId != null && FGResponse.data.paymentPlanId > 0)));
        },


        // if the card is unknown or not accepted
        invalidCardDoNotGoForward: function () {
            $('#btn-billing-submit').addClass('disabled').attr('disabled', true);
            $('#payment_form').unbind('submit').bind('submit', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                e.stopPropagation();
                return false;
            });
        },

        /**
         * Bind to the order summary details down arrow link
         */
        bindToOrderSummaryDetails: function () {

            $('#orderSummary button.open_ind').on('click', function () {
                $(this).parents('li').find('div.cost-breakout').slideDown('slow', function() { $(this).show(); });
                $(this).parents('li').find('button.close_ind').show();
                $(this).hide();
                return false;
            });

            $('#orderSummary button.close_ind').on('click', function () {
                $(this).parents('li').find('div.cost-breakout').slideUp('slow', function() { $(this).hide(); });
                $(this).parents('li').find('button.open_ind').show();
                $(this).hide();
                return false;
            });
        },

        /**
         * Bind to the checkout as a guest button
         */
        bindToCheckoutAsGuestButton: function () {

            var self = this;

            //Bind to the checkout as guest button
            $('#btn-checkout-guest').on('click', function (e) {

                e.preventDefault();

                var Ajax = new FG.Ajax('checkout/checkout_as_guest');

                try {

                    Ajax.setSuccessCallback(function (FGResponse) {

                        //Set login type cookie
                        $.cookie('FG_LOGIN_TYPE', 'Guest', {path: '/'});

                        setTimeout(function () {
                            if (FGResponse.data !== null) {
                                window.location.href = FGResponse.data.url;
                            } else {
                                window.location.reload();
                            }
                        }, 200);
                    });

                    Ajax.send();

                } catch (AjaxException) {
                    Ajax.error(AjaxException.msg);
                }
            });
        },

        /**
         * Build shipping options drop downs for each XTicket
         * @param object    argumentObject      key value pair object whose name is the value to pass shipping option, and whose value is the DOM value
         * eg.
         *  buildShippingOptionsDD( { 'countryName' : 'United States', 'billingZipCode' : 78744 } ); // and so on
         */
        buildShippingOptionsDD: function (argumentObject) {

            //Disable the next button
            $('#btn-shipping-submit').attr('disabled', 'disabled').val('Please Wait...');

            var self = this;


            // Contains mappings for M, W, P, D to english strings
            var serviceClassObject = {
                'M': 'Mail',
                'W': 'Will Call',
                'P': 'Print Pass',
                'D': 'Mobile Delivery',
                'H': 'Digital PrintPass'
            };

            var xTicketIdArray = [];

            // Ajax object to get shipping options from the server
            var Ajax = new FG.Ajax('cart/shipping_options');

            //Checkout accordion shipping options div
            if ($('.cls-shipping-option').length == 0) { return false; }

            var countryName = 'countryName' in argumentObject? argumentObject.countryName : null;

            //Build an array of xTicketId(s) for consistency checking on the server
            $('.cls-shipping-option').each(function () {
                xTicketIdArray.push([
                    ['xTicketId', $(this).data('xticketid')],
                    ['priceName', $(this).data('pricename')]
                ]);
            });

            try {
                Ajax.setRequestData({ xTicketIdArray: xTicketIdArray, countryName: countryName, csrf_token: CSRF_TOKEN });

                //If we have a successful response :)
                Ajax.setSuccessCallback(function (FGResponse) {

                    $('#shipping_state_label').text(window.FGTLibs.i18n.t('State') + ' *');
                    $('label[for="shipping_zip"]').text(window.FGTLibs.i18n.t('Zip/Postal Code') + ' *');

                    // All the states for this particular country
                    var countryStateArray = FGResponse.data.countryStateArray,
                        contactBillingState = $('#contactBillingState').val().toUpperCase();


                    if (countryStateArray.length > 0) {

                        $('#shipping_select_state').find('option').remove().end();

                        $('#shipping_select_state').append($('<option>', { value: '', text: window.FGTLibs.i18n.t('Please Select') }));

                        $.each(countryStateArray, function (index, value) {

                            $('#shipping_select_state').append($('<option>', {
                                value: value.stateAbbr,
                                text: value.stateName,
                                selected: (contactBillingState == value.stateAbbr || contactBillingState == value.stateName)
                            }));

                        });

                        $('#shipping_state_label').parent().show();
                    } else {
                        $('#shipping_select_state').find('option').remove().end();
                        $('#shipping_state_label').parent().hide();
                        $('#shipping_state_other').hide();
                    }

                    //The UK calls will call COBO, change the prefix.
                    if (FGResponse.data.localeName == 'en_GB.utf8' || FGResponse.data.localeName == 'en_GB') {

                        serviceClassObject.W = 'COBO';
                        $("label[for='willcall_firstName']").text('COBO First Name');
                        $("label[for='willcall_lastName']").text('COBO Last Name');
                    }

                    /**
                     * All possible shipping options
                     * @type {array}
                     */
                    var shippingOptionArray = FGResponse.data.shippingOptionArray;

                    $.each(shippingOptionArray, function (xTicketId, shippingOptionChargeArray) {

                        var $div = $('<div>'),
                            $p,
                            key, rows, key2, $select, shippingId, shippingQueueId, totalCost, messageEncoded, serviceClass, carrierId, name,
                            serviceClassName, $option, packageShipping, packageInstanceId, changeShipping = false, changeArray = new Array();

                        //Determine what the event name is
                        for (key in xTicketIdArray) {

                            rows = xTicketIdArray[key];

                            for (key2 in rows) {

                                if (rows[key2][0] == 'xTicketId' && rows[key2][1] == xTicketId) {

                                    $p = '<p>' + $('#span-line-item-name-' + xTicketId).html() + '</p>'
                                }
                            }
                        }

                        $select = $('<select>')
                            .attr('id', 'sel-sopt-' + xTicketId)
                            .attr('name', 'shippingId[]')
                            .attr('class', 'cls-shopt-xticket')
                            .attr('data-xTicketId', xTicketId)
                            .addClass('f-reset f-select required unchanged');

                        $select.append($('<option>').attr('value', '').text(window.FGTLibs.i18n.t('Please Select Shipping Option')));

                        for (key in shippingOptionChargeArray) {

                            shippingId = shippingOptionChargeArray[key].shippingId;
                            shippingQueueId = shippingOptionChargeArray[key].shippingQueueId;
                            totalCost = shippingOptionChargeArray[key].totalCost;
                            messageEncoded = encodeURIComponent(shippingOptionChargeArray[key].message);
                            serviceClass = shippingOptionChargeArray[key].serviceClass;
                            packageShipping = shippingOptionChargeArray[key].isPackage;
                            packageInstanceId = shippingOptionChargeArray[key].packageInstanceId;

                            name = shippingOptionChargeArray[key].name;
                            serviceClassName = serviceClassObject[serviceClass];
                            carrierId = shippingOptionChargeArray[key].carrierId;

                            $option = $('<option>')
                                .attr('value', shippingId)
                                .attr('data-shippingId', shippingId)
                                .attr('data-shippingQueueId', shippingQueueId)
                                .attr('data-messageEncoded', messageEncoded)
                                .attr('data-serviceClass', serviceClass)
                                .attr('data-totalCost', totalCost)
                                .attr('data-packageInstanceId', packageInstanceId)
                                .attr('data-carrierId', carrierId)
                                .text((name == serviceClassName ? name : serviceClassName + ': ' + name));

                            if (serviceClass == 'M' && packageShipping == true) {
                                $option.attr('selected', 'selected');
                                changeShipping = true;
                                changeArray.push(shippingId);
                            }

                            $select.append($option);
                            if (typeof $select.data('packageinstanceid') != 'number' && packageShipping == true) {
                                $select.attr('data-packageInstanceId', packageInstanceId);
                            }
                        }

                        $('#div-shipping-option-' + xTicketId).siblings('.event-date-doors').find('.event-ticket-type').html($p);
                        $('#div-shipping-option-' + xTicketId + ' .select-delivery').html($select);
                        $('#div-shipping-option-' + xTicketId + ' .delivery-message').attr('id', 'div-message-' +xTicketId);


                        //Set shipping option selections made by the user prior, assuming a page reload
                        if (FGResponse.data.shippingOrderArray != undefined && FGResponse.data.shippingOrderArray !== null) {

                            //Select a default or user selected option if one is set.
                            for (key in FGResponse.data.shippingOrderArray) {

                                var shippingOrder = FGResponse.data.shippingOrderArray[key];

                                //Loop through each option for this xTicket and see if we can find a match to set
                                $('#sel-sopt-' + shippingOrder.xTicketId + ' > option').each(function () {

                                    if ($(this).data('shippingid') == shippingOrder.shippingId && $(this).data('shippingqueueid') == shippingOrder.shippingQueueId) {

                                        $(this).attr('selected', 'selected');

                                        //Add the shipping option message below the shipping option drop down
                                        $('#div-message-' + shippingOrder.xTicketId).addClass('col-xs-12').html(FG.Base.nl2br(shippingOrder.message, true));

                                        //Add a service class for this selected shipping option
                                        $('#txt-service-class-' + shippingOrder.xTicketId).val(shippingOrder.serviceClass);
                                    }
                                });
                            }
                        }

                        //Bind to the dropdown for the shipping option and write this value back to the xTicket
                        self.bindToShippingOptionDD();

                        if (changeShipping == true) {
                            var removeVal = changeArray.shift();
                            $('select.unchanged > option[value=' + removeVal + ']').change();
                            $('select.unchanged > option[value=' + removeVal + ']').parent().removeClass('unchanged');
                        }

                        // Automatically select the option when it's the only one
                        if (shippingOptionChargeArray.length === 1) {
                            $('#sel-sopt-' + xTicketId + ' option:eq(1)')
                                .prop('selected', true)
                                .trigger('change');
                        }

                        //Enable the button
                        $('#btn-shipping-submit').removeAttr('disabled').attr('disabled', false).val('Next');

                    });

                    //Set a failure callback method
                    Ajax.setFailureCallback(function () {
                        $('#btn-shipping-submit').removeAttr('disabled').attr('disabled', false).val('Next');
                    });
                    //Show hide shipping fields.
                    self.bindToServiceClass();

                    //Collapse package options
                    self.collapsePackages();
                    self.collapseCommonShipping();
                    self.selectSingleShippingOption();

                });

                //Make the request
                Ajax.send();


            } catch (AjaxException) {
                Ajax.error(AjaxException);
            }
        },

        /**
         * If there is only one shipping option select it and let the user move on with life
         */
        selectSingleShippingOption: function() {
            var childcount = 0;
            var selectval = 0;

            $('select[id^=sel-sopt]').each(function() {
                childcount = $(this).children('option[data-shippingid]').length;
                if (childcount == 1) {
                    selectval = $(this).children('option[data-shippingid]').val();
                    $(this).val(selectval);
                    $(this).change();
                }
            });
        },

        collapseCommonShipping: function() {
            // Setting function variables
            var shippingArray = [], titles = {}, myshippingids = [], j = 0, self = this;
            // Begin by removing group titles if changing country
            $('.grouped-title').remove();

            // Gathering options
            $('select[id^=sel-sopt]').each(function() {
                var shippingIds = '';
                $(this).children('option[data-shippingid]').each(function() {
                    shippingIds += $(this).data('shippingid') + ',';
                });
                // only group GA tickets
                if ($(this).parent().data('general-admission')){
                    $(this).attr('data-shippingids', shippingIds);
                    var eventTitle = $(this).closest('.event').find('.shipping-title').text();
                    shippingArray.push({
                        id: $(this).attr('id'),
                        shippingids: shippingIds,
                        eventTitle: eventTitle
                    });
                }
            });

            // Organizing options
            $.each(shippingArray, function(i) {
                if ($.inArray(this.shippingids, myshippingids) == -1) {
                    myshippingids.push(this.shippingids);
                    // hiding entire block of code instead of just the select, for visual purposes
                    $('select[data-shippingids="'+ myshippingids[j] +'"]').parent().parent().parent().hide();
                    $('select[data-shippingids="'+ myshippingids[j] +'"]').last().parent().parent().parent().show();
                    // Change binded on select and not entire block. Changes all except last (this), to prevent infnite loop
                    $('select[data-shippingids="'+ myshippingids[j] +'"]').last().show().bind('change', function(e) {
                        var myval = $(this).val();
                        $('select[data-shippingids="'+ $(this).data('shippingids') +'"]').val(myval);
                        $('select[data-shippingids="'+ $(this).data('shippingids') +'"]').not( '#' + $(this).attr('id') ).change();
                    });
                    // j is for the iterations of shipping options
                    j++;
                }

                // shippingids as key to an array of event titles  i.e. "123, 1234":["Day One","Day Two"]
                // key is a string because of chris's work above to group exact same shipping options
                if (titles[this.shippingids]) {
                    titles[this.shippingids].push(this.eventTitle);
                } else {
                    titles[this.shippingids] = [this.eventTitle];
                }

                self.collapsedOptions = true;
            });

            // Adding combined titles to represent grouping
            $.each(titles, function(k, v) {
                if (v.length >= 2) {
                    v = v.join(', <br>');
                    // uses shipping ids as key (k) to assign the paired titles with their event title.
                    var $groupedSelects = $('select[data-shippingids="'+ k +'"]').closest('.event');
                    $groupedSelects.find('.shipping-title').hide();
                    $groupedSelects.find('.col-xs-5').prepend('<h4 class="grouped-title">' + v + '</h4>')
                    $groupedSelects.find('select:visible').addClass('groupedSelect');

                    $groupedSelects.find('.event-date-doors.col-xs-7').hide();
                    $('.cls-shipping-option')
                        .addClass('col-xs-7')
                        .css({
                            'padding-left': '0',
                            'padding-right': '0',
                        });
                }
            });
        },

        collapsePackages: function() { $('select[id^=sel-sopt]').each(function() {}); },

        /**
         * Bind to the dropdown for the shipping option and write this value back to the xTicket
         */
        bindToShippingOptionDD: function () {

            var self = this;

            $('.cls-shopt-xticket').unbind('change').bind('change', function () {
                self.previousOrderTotal = $('#span-order-subtotal').data('the-total');
                try {

                    var xTicketId = $(this).data('xticketid');
                    var xTicketArray = [];
                    var allSet = true;
                    $('#div-summary-insurance').hide();

                    self.Ajax.setURL('cart/set_shipping_option');
                    self.Ajax.setRequestType('post');
                    self.Ajax.setMessageDiv('div-message-' + xTicketId);

                    $('.cls-shopt-xticket').each(function() {

                        var selected = $(this).find('option:selected'),
                            xTicketId = $(this).data('xticketid'),
                            shippingId = selected.data('shippingid'),
                            shippingQueueId = selected.data('shippingqueueid'),
                            message = decodeURIComponent(selected.data('messageencoded')),
                            serviceClass = selected.data('serviceclass');

                        //Refresh shipping option description
                        $('#div-message-' + xTicketId).slideDown('slow', function () {
                            $(this).html((message != undefined && message != 'undefined')? message : '');
                            $(this).addClass('col-xs-12');
                        });

                        //Add service class
                        if (serviceClass != undefined) {
                            $('#txt-service-class-' + xTicketId).val(serviceClass);
                        }

                        //Remove any error messages
                        $('#sel-sopt-' + xTicketId + '_error').addClass('hide').addClass('hidden');
                        $('#sel-sopt-' + xTicketId).removeClass('invalid');

                        //This section handles showing or hiding the error message when a PO Box is entered and UPS is selected as the shipping carrier.
                        var addressInputElement = document.getElementById("shipping_address");
                        var shippingFormSelector = document.querySelectorAll('#shipping_form .event select.cls-shopt-xticket')
                        var isUPS = Array.from(shippingFormSelector).some(function(select) {
                             // Check if selected carrier is UPS (carrier ID = 2) in delivery option dropdown
                            return Number(select.options[select.selectedIndex].dataset.carrierid) === 2
                        });
                        // Regex to match PO Box variations
                        var poBoxRegex = /(^|\s)(P\.?\s*O\.?|PO|P\.O\.?)\s*(Box|Office)?(\s|$)/i;
                        var isPOBox = poBoxRegex.test(addressInputElement.value);
                        if($('#shipping_address').hasClass('shipping_error') && !isUPS){
                            $('#shipping_address').removeClass('shipping_error');
                            $('.shipping_service_error_msg').addClass('hide');
                        } else if(isPOBox && isUPS){
                            $('#shipping_address').addClass('shipping_error');
                            $('.shipping_service_error_msg').removeClass('hide');
                        }

                        xTicketArray.push({
                            xTicketId: xTicketId,
                            shippingId: shippingId,
                            shippingQueueId: shippingQueueId,
                            serviceClass: serviceClass
                        });

                    });

                    self.Ajax.setRequestData({ xTicketArray: xTicketArray, csrf_token: CSRF_TOKEN});

                    self.Ajax.setSuccessCallback(function (FGResponse) {

                        //If we have data
                        if (FGResponse.data !== null) {

                            //Refresh the order summary fragment
                            $('#order_summary_fragment').slideDown('slow', function () {
                                $(this).html(FGResponse.data.summary);
                                // updating the promotion price in promotion.twig
                                var appliedPromotionTotal = $('.applied_promotion_total').data('appliedPromotionTotal');
                                // Check if promotion total is null, undefined, empty, or zero
                                var normalizedValue = String(appliedPromotionTotal || '')
                                .replace(/[^0-9.-]/g, '') // remove currency symbols but preserve negative sign
                                .trim();
                                var hasPromotion = normalizedValue !== '' && Math.abs(Number(normalizedValue)) > 0;
                                if (!hasPromotion) {
                                    // No promotion applied - show promo code form
                                    $('.promo-success-wrapper').hide();
                                    $('.promoForm').show();
                                    $('.btn-apply-promo-code').removeClass('disabled').prop('disabled', false);
                                    $('.toggle_promo_code[data-action="open"]').show();
                                    $('.toggle_promo_code[data-action="close"]').hide();
                                    $('.applied_promotion_total').parent().remove();
                                } else {
                                    // Promotion applied - show success wrapper and hide form
                                    $('.promo-success-wrapper').show();
                                    $('.promoForm').hide();
                                    $(".promo-success").text(appliedPromotionTotal);
                                    $('.toggle_promo_code[data-action="close"]').show();
                                    $('.toggle_promo_code[data-action="open"]').hide();
                                }

                                // Updating the total order price for pay later text message.
                                var totalOrderPrice = $('#span-order-subtotal').data('theTotal');
                                $("#paypal-paylater-message").attr("data-pp-amount", totalOrderPrice);
                            });

                            self.bindToOrderSummaryDetails();
                        }
                        //Show hide shipping fields.
                        self.bindToServiceClass();

                    });

                    //Show hide shipping fields.
                    self.Ajax.setFailureCallback(function () { self.bindToServiceClass(); });

                    self.xTicketCount = self.xTicketCount + 1;

                    $('select[id^=sel-sopt]:visible option:selected').each(function() {
                        if (!$(this).val()) { allSet = false; }
                    });

                    // Only send this once. When the countries get changed still only send this once.
                    if ($(this).not('.groupedSelect').length // Make sure this is not a select for grouped shipping (causing an extra post)
                        && xTicketArray.length == $('div[id^="div-shipping-option"]').length // Make sure every shipping option has been added to the xticket array
                        && allSet // Make sure every shipping select has a option with a value selected
                    ) {
                        self.Ajax.send();
                        self.sentArray = xTicketArray;
                    }

                } catch (AjaxException) { self.Ajax.error(AjaxException.msg); }
            });
        },

        /**
         * Show hide delivery options form when a particular service class is selected
         * i.e when the shipping option changes from mail to will call, the fields are different and the form needs to slide down
         */
        bindToServiceClass: function () {

            var self = this,
                mail = false,
                willcall = false,
                digitalPrintPass = false,
                mobileDelivery = false,
                willCallFirstName,
                willCallLastName,
                shippingFirstName,
                shippingLastName;

            var shippingValidatorConfig = [
                { id: 'shipping_firstName', type: ['noHTML', 'required'] },
                { id: 'shipping_lastName',  type: ['noHTML', 'required'] },
                { id: 'shipping_address',   type: ['noHTML', 'required'] },
                { id: 'shipping_address2',  type: ['noHTML'] },
                { id: 'shipping_city',      type: ['noHTML', 'required'] },
                { id: 'shipping_zip',       type: ['noHTML', 'required'] }
            ];
            var willcallValidatorConfig = [
                { id: 'willcall_firstName', type: ['noHTML', 'required'] },
                { id: 'willcall_lastName',  type: ['noHTML', 'required'] },
            ];
            var highlightInput = function(element, validation) {
		        var msgId = $(element).attr('id').concat('-error');

                if($(element).parents('form').find('div#' + msgId ).length > 0){
                        $(element).attr('aria-describedby', '');
                        $(element).parents('form').find('div#' + msgId ).remove();
                }

                $(element)[validation.pass ? 'removeClass' : 'addClass']('invalid');
                $(element).parent()[validation.pass ? 'removeClass' : 'addClass']('invalid');


                if (!validation.pass && validation.message !== '') {
                        var msgAttr = validation.message.toLowerCase().replace(/\s/g, '_');
                        if($(element).parents('form').find('div#' + msgId).length == 0){
                                $(element).attr('aria-describedby', msgId);
                                $(element).parent()
                                  .append('<div id="' + msgId + '" class="error-msg invalid" data-msg-text="' + msgAttr + '">' + validation.message + '</div>')
                                  .show();
                        }
                }
            };
            self.shippingValidator = new FGTLibs.InputValidator(shippingValidatorConfig, highlightInput);
            self.willcallValidator = new FGTLibs.InputValidator(willcallValidatorConfig, highlightInput);

            $('#shipping_form').find('select.cls-shopt-xticket option:selected').each(function () {
                if ('M' === $(this).data('serviceclass')) {
                    mail = true;
                }
                if ('W' === $(this).data('serviceclass')) {
                    willcall = true;
                }
                if ('D' === $(this).data('serviceclass')  ) {
                    mobileDelivery = true;
                }
                if ('H' === $(this).data('serviceclass')) {
                    digitalPrintPass = true;
                }
            });

            if (!(mail || willcall || digitalPrintPass || mobileDelivery)) {
                $('#serviceClassInput').val('');

                // Hide will call
                $('#scs-W').slideUp('fast', function () {
                    $(this).hide();
                });

                // Hide mail
                $('#scs-M').slideUp('fast', function () {
                    $(this).hide();
                });

                // Hide digital delivery
                $('#scs-H').slideUp('fast', function () {
                    $(this).hide();
                });

            } else {
                if (mail == true) {
                    //Assign will call names to mail, to save typing
                    willCallFirstName = $('#willcall_firstName').val();
                    willCallLastName = $('#willcall_lastName').val();

                    $('#shipping_firstName').val(willCallFirstName);
                    $('#shipping_lastName').val(willCallLastName);
                    $('#serviceClassInput').val('M');

                    // Show mail
                    $('#scs-M').slideDown('fast', function () {
                        $(this).show();
                    });
                    if($('#smsdata').data('orderTrackingOn')){
                        $('#scs-H, #sms-order-tracking-opt-in-wrapper').slideDown('fast', function () {
                            $(this).show();
                        });
                    }
                    (mobileDelivery || digitalPrintPass) ? '' : $('#digital-delivery-opt-in-wrapper').hide();
                    $("#scs-M").css("border-bottom", "1px solid #cccccc");
                    (willcall) ? $("#scs-H").css("border-bottom", "1px solid #cccccc") : '';
                }  else {
                    // hide mail
                    $('#scs-M').slideUp('fast', function () {
                        $(this).hide();
                    });
                                    }

                if ((mobileDelivery || digitalPrintPass )) {
                    if (mobileDelivery) {
                        $('#serviceClassInput').val('D');
                    }
                    if (digitalPrintPass) {
                        $('#serviceClassInput').val('H');
                    }

                    // show sms
                    if($('#smsdata').data('smsOn')){
                        $('#scs-H, #digital-delivery-opt-in-wrapper').slideDown('fast', function () {
                            $(this).show();
                        });
                    }
                    (mail) ? '' : $('#sms-order-tracking-opt-in-wrapper').hide();
                    (willcall) ? $("#scs-H").css("border-bottom", "1px solid #cccccc") : '';
                }

                if (willcall == true) {
                    shippingFirstName = $('#shipping_firstName').val();
                    shippingLastName = $('#shipping_lastName').val();

                    if (shippingFirstName != '' && typeof shippingFirstName != 'undefined' && shippingFirstName != null) {
                        $('#willcall_firstName').val(shippingFirstName);
                    }

                    if (shippingLastName != '' && typeof shippingLastName != 'undefined' && shippingLastName != null) {
                        $('#willcall_lastName').val(shippingLastName);
                    }

                    $('#serviceClassInput').val('W');

                    // Show will call
                    $('#scs-W').slideDown('fast', function () {
                        $(this).show();
                    });

                    (!mail && !mobileDelivery && !digitalPrintPass) ? $('#scs-H').hide() : '';

                } else {
                    // hide will call
                    $('#scs-W').slideUp('fast', function () {
                        $(this).hide();
                    });
                }
            }

            if(!($('#digital-delivery-opt-in,#sms-order-tracking-opt-in').is(':visible'))){
                $('#scs-H').slideUp('fast', function () {
                    $(this).hide();
                });
            }
        },

        /**
         *
         * @param argumentObject - has
         */
        buildOrderHistoryStateDD: function(argumentObject) {
            var countryName = ('countryName' in argumentObject) ? argumentObject.countryName : null,
                currState = ('currState' in argumentObject) ? argumentObject.currState : null,
                countryStateArray,
                contactBillingState = $('#shipping_state_other').val();

            try {
                this.Ajax.setURL('cart/billing_states');
                this.Ajax.setRequestType('get');
                this.Ajax.setRequestData({ countryName: countryName });
                this.Ajax.setSuccessCallback(function (FGResponse) {

                    //If we have no data, then return.
                    if (FGResponse.data == null) { return false; }

                    countryStateArray = FGResponse.data.countryStateArray;

                    if (countryStateArray.length > 0) {

                        $('#shipping_state_label, #shipping_select_state').show();
                        $('#shipping_state_other').hide();

                        $('#shipping_select_state').find('option').remove().end();

                        $('#shipping_select_state').append($('<option></option>',
                            { value: '', text: '-- ' + window.FGTLibs.i18n.t('Select State') + ' --' }));

                        $.each(countryStateArray, function (index, value) {
                            $('#shipping_select_state').append($('<option></option>', {
                                value: value.stateAbbr,
                                text: value.stateName,
                                selected: (contactBillingState == value.stateAbbr || contactBillingState == value.stateName)
                            }));
                        });
                    } else {

                        if (countryName == 'United Kingdom') {
                            $('#shipping_state_label, #shipping_select_state, #shipping_state_other').hide();
                        } else {
                            $('#shipping_select_state').hide();
                            $('#shipping_state_other').removeClass('hide');
                            $('#shipping_state_label, #shipping_state_other').show();
                        }
                    }
                });

                this.Ajax.send();

            } catch (AjaxException) {
                this.Ajax.error(AjaxException.msg);
            }
        },

        /**
         * Build billing state drop downs
         * @param object    argumentObject      key value pair object
         * eg.
         *  buildBillingCountryStateDD( { 'countryName' : 'United States', 'billingZipCode' : 78744 } ); // and so on
         */
        buildBillingCountryStateDD: function (argumentObject, copyState) {
            var shouldCopyState = copyState !== undefined ? copyState : false;
            var countryName = ('countryName' in argumentObject) ? argumentObject.countryName : null,
                countryStateArray,
                contactBillingState;

            try {

                var Ajax = new FG.Ajax('cart/billing_states');
                Ajax.setURL('cart/billing_states');
                Ajax.setRequestType('get');
                Ajax.setRequestData({ countryName: countryName });

                Ajax.setSuccessCallback(function (FGResponse) {
                    //If we have no data, then return.
                    if (FGResponse.data == null) { return false; }

                    $('#billing_state_label').text(window.FGTLibs.i18n.t('State') + ' *');
                    $('label[for="billing_zip"]').text(window.FGTLibs.i18n.t('Zip/Postal Code') + ' *');
                    if (countryName === 'Canada'){
                        $('#casl_terms_block').removeClass('hide');
                    } else {
                        $('#casl_terms_block').addClass('hide');
                    }

                    countryStateArray = FGResponse.data.countryStateArray;
                    contactBillingState = $('#contactBillingState').val();

                    if (countryStateArray.length > 0) {

                        $('#billing_state_label').parent().show();
                        $('#billing_state_other').hide();
                        $('#billing_select_state').find('option').remove().end();
                        $('#billing_select_state').append($('<option></option>', {
                            value: '',
                            text: '-- ' + window.FGTLibs.i18n.t('Select State') + ' --'
                        }));

                        $.each(countryStateArray, function (index, value) {
                            $('#billing_select_state').append($('<option></option>', {
                                value: value.stateAbbr,
                                text: value.stateName,
                                selected: (contactBillingState == value.stateAbbr || contactBillingState == value.stateName)
                            }));
                        });
                        if (shouldCopyState) {
                            $('#billing_select_state').val($('#shipping_select_state').val());
                        }
                        // Send a custom event notification that this select element has changed
                        $('#billing_select_state').trigger('fgt.billingStateSelectChange');
                    } else {
                        $('#billing_state_label').parent().hide();
                        $('#billing_select_state').find('option').remove().end();
                        $('#billing_state_other').val('');
                    }
                });

                Ajax.send();

            } catch (AjaxException) {
                Ajax.error(AjaxException.msg);
            }
        },


        /**
         * When the shipping country DD changes, then the shipping options need to be refreshed from the server.
         */
        bindToShippingCountry: function () {

            var self = this;

            $('#shipping_country').on('change', function () {

                //Clear out shipping options when the DD is refreshed
                self.clearShippingOptions();
                self.xTicketCount = 0;

                var shippingCountryName = $(this).val();
                self.buildShippingOptionsDD({ countryName: shippingCountryName });
                $('.newsletter_opt_in').prop('checked', self.isOptInDefaultTrueByCountry());
            });
        },

        /**
         * Bind to the billing country dropdown building the states for this country
         */
        bindToBillingCountry: function () {

            var self = this;

            $('#billing_country').on('change', function (event, copyStateObj) {
                var copyState = copyStateObj ? copyStateObj.copyState : false;
                var billingCountryName = $(this).val();
                self.buildBillingCountryStateDD({ countryName: billingCountryName }, copyState);
                $('.newsletter_opt_in').prop('checked', self.isOptInDefaultTrueByCountry());
            });
        },

        isOptInDefaultTrueByCountry: function () {
            var defaultNoCustomers = ['Canada', 'United Kingdom', 'Austria', 'Belgium', 'Bulgaria', 'Croatia',
                'Cyprus', 'Czech Republic', 'Denmark', 'Estonia', 'Finland', 'France', 'Germany', 'Greece',
                'Hungary', 'Ireland', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg', 'Malta', 'Netherlands',
                'Poland', 'Portugal', 'Portugal', 'Romania', 'Slovakia', 'Slovenia', 'Spain', 'Sweden'];
            var optDefaultTrueByCustomer = defaultNoCustomers.filter(function(el) {
                return (el === $('#billing_country').val() || el === $('#shipping_country').val())
            }).length === 0;
            var optDefaultTrueByLabel = $('#label_country').val() != 'United Kingdom';
            var optInDefaultTrue = optDefaultTrueByCustomer && optDefaultTrueByLabel;
            return optInDefaultTrue;
        },

        /**
         * Hide insurance summary when billing address changes
         */
        bindInsuranceHandlers: function () {
            var self = this;

            $('#billing_country').on('change', function () {
                if (self.currentStep() <= 1) {
                    $('#div-summary-insurance').hide();
                }
            });

            $('#billing_select_state').on('change', function () {
                $('#div-summary-insurance').hide();
            });
        },

        /**
         * Show/hide create new account password fields if the checkbox to create a new account is checked
         */
        bindToCreateAccount: function () {
            $('#create_acct').on('click', function () {

                if ($(this).is(':checked')) {
                    $('#div-create-account-password-fields').fadeIn('slow', function () { $(this).show(); });
                } else {
                    $('#div-create-account-password-fields').fadeOut('slow', function () { $(this).hide(); });
                }
            });
        },

        /**
         * Clear out all user selected shipping options when the page loads
         * @since 6/7/2013
         */
        clearShippingOptions: function () {

            try {
                $('#shipping_address').val('');
                $('#shipping_city').val('');
                $('#shipping_zip').val('');
                this.Ajax.setURL('cart/clear_shipping_options');
                this.Ajax.setRequestData({ countryName: $('#shipping_country').val(), csrf_token: CSRF_TOKEN });
                this.Ajax.send();
            } catch (AjaxException) {
                this.Ajax.error(AjaxException.msg);
            }
        },

        /**
         * Show a modal that explains what a CVC number is on a credit card
         */
        bindToInsuranceForm: function () {

            var self = this;

            $('#insurance_form').on('submit', function (e) {
                e.preventDefault();
                var Ajax = new FG.Ajax('checkout/save_insurance');

                try {
                    Ajax.setRequestData({'insurance': $('#insurance').prop('checked') ? 1 : 0, csrf_token: CSRF_TOKEN});
                    Ajax.setSuccessCallback(function (FGResponse) {
                        FG.Checkout.prototype.makeStepActive('collapseFour');

                        $('#order_summary_fragment').slideDown('slow', function () {
                            $(this).html(FGResponse.data.summary);
                        });

                        $('#div-summary-insurance').slideDown('slow',function () {
                            $(this).html(FGResponse.data.insuranceSummary);
                        }).parent().parent().parent().parent().addClass('complete');

                        if (FGResponse.data.paymentPlan != undefined) {
                            $('#div-payment-plan-table').html(FGResponse.data.paymentPlan);
                        }

                        self.bindToOrderSummaryDetails()
                    });

                    Ajax.setFailureCallback(function (FGResponse) {
                      if (['CheckoutException', 'SessionException'].indexOf(FGResponse.errorType) !== -1) {
                            //make the unavailable div active and show error reason
                            $('#insurance_unavailable:hidden').removeClass('hide');
                            $('#insurance_form:visible').addClass('hide');
                        }
                    });
                    Ajax.send();

                } catch (AjaxException) {
                    Ajax.error(AjaxException.msg);
                }
            });
        },

        /**
         * Handle next button click for delivery information form
         */
        bindToShippingForm: function (pageType) {

            var self = this,
                $shippingForm = $('#shipping_form'),
                $btnShippingSubmit = $('#btn-shipping-submit'),
                ladda = new FG.Ladda($btnShippingSubmit.get(0));

            var shippingValidatorConfig = [
                { id: 'shipping_firstName', type: ['noHTML', 'required'] },
                { id: 'shipping_lastName',  type: ['noHTML', 'required'] },
                { id: 'shipping_address',   type: ['noHTML', 'required'] },
                { id: 'shipping_address2',  type: ['noHTML'] },
                { id: 'shipping_city',      type: ['noHTML', 'required'] },
                { id: 'shipping_zip',       type: ['noHTML', 'required'] }
            ];
            var willcallValidatorConfig = [
                { id: 'willcall_firstName', type: ['noHTML', 'required'] },
                { id: 'willcall_lastName',  type: ['noHTML', 'required'] },
            ];
            var highlightInput = function(element, validation) {
		        var msgId = $(element).attr('id').concat('-error');

                if($(element).parents('form').find('div#' + msgId ).length > 0){
                        $(element).attr('aria-describedby', '');
                        $(element).parents('form').find('div#' + msgId ).remove();
                }

                $(element)[validation.pass ? 'removeClass' : 'addClass']('invalid');
                $(element).parent()[validation.pass ? 'removeClass' : 'addClass']('invalid');


                if (!validation.pass && validation.message !== '') {
                        var msgAttr = validation.message.toLowerCase().replace(/\s/g, '_');
                        if($(element).parents('form').find('div#' + msgId).length == 0){
                                $(element).attr('aria-describedby', msgId);
                                $(element).parent()
                                  .append('<div id="' + msgId + '" class="error-msg invalid" data-msg-text="' + msgAttr + '">' + validation.message + '</div>')
                                  .show();
                        }
                }
            };
            self.shippingValidator = new FGTLibs.InputValidator(shippingValidatorConfig, highlightInput);

            // don't create willcallValidator in 'user' case
            if (pageType === 'user') {
                self.willcallValidator = null;
            } else {
                self.willcallValidator = new FGTLibs.InputValidator(willcallValidatorConfig, highlightInput);
            }

            $shippingForm.off('submit').on('submit', function (e) {
                var $smsPhone = $('#sms_phone');
                $('#msg-billing, #msg-shipping').hide(); // Hide the shipping/billing message

                e.preventDefault();

                FG.Base.resetErrors($(this));

                var shippingOptionValid = true,
                    serviceClassArray = [],
                    Ajax,
                    selected,
                    country = $('#shipping_country').val(),
                    state = $('#shipping_select_state').val(),
                    xorder,
                    shippingOptionsGTM = [],
                    $selectedServiceClasses;

                //Add logic to validate the shipping options DDs
                $('.cls-shopt-xticket').each(function () {

                    selected = $(this).find('option:selected');

                    if (selected.val() == '') {
                        $('#' + $(this).attr('id')).addClass('invalid');
                        $('#' + $(this).attr('id') + '_error').removeClass('hide').addClass('invalid').removeClass('hidden');
                        shippingOptionValid = false;
                    } else {
                        $('#' + $(this).attr('id') + '_error').removeClass('invalid').addClass('hide').addClass('hidden');
                        shippingOptionsGTM.push(selected.text());
                    }
                    serviceClassArray.push(selected.data('serviceclass'));
                });

                if (shippingOptionValid == false) {
                    return false;
                }

                $selectedServiceClasses = $('#shipping_form').find('select.cls-shopt-xticket option:selected');

                var isMail = $selectedServiceClasses.toArray().reduce(function(acc, element){
                    return $(element).data('serviceclass') === 'M' ? true : acc;
                }, false);

                var isWillcall = $selectedServiceClasses.toArray().reduce(function(acc, element){
                    return $(element).data('serviceclass') === 'W' ? true : acc;
                }, false);

                // Run some basic validation.
                if (isMail || isWillcall) {
                    if (!self[isMail ? 'shippingValidator' : 'willcallValidator'].checkAll().pass) {
                        return false;
                    }
                }

                // run validation in 'user' case
                if (pageType === 'user') {
                    if(self.shippingValidator && !self.shippingValidator.checkAll().pass) {
                        return false;
                    }
                }

                var inServiceClass = $.inArray('M', serviceClassArray) !== -1;
                // If the country is America or Mexico, and the service class is mail, ensure a value for state.
                if ((MY_COUNTRIES_ARRAY.indexOf(country) !== -1) && inServiceClass) {
                    if (!self.isValueValid(state)) {
                        if (inServiceClass) {
                            $('#shipping_state_label, #shipping_select_state').addClass('invalid');
                            return false;
                        } else {
                            $('#shipping_state_label, #shipping_select_state').removeClass('invalid');
                        }
                    }
                }

                $btnShippingSubmit.attr('disabled', 'disabled');

                ladda.start();

                if (pageType && pageType === 'user') {
                    xorder = this.action.match(/\d+$/)[0];
                    Ajax = new FG.AjaxJob('user/save_shipping/' + xorder);
                    userSaveShipping();
                    return;
                }

                self.displaySameAsShippingOption();
                self.copyShippingToBilling();

                resetShippingErrors();

                Ajax = new FG.AjaxJob('checkout/save_shipping');

                var shouldValidateSMSPhoneNo = shouldValidateSMSPhone();

                if (!shouldValidateSMSPhoneNo && isSMSConsent) {
                    return;
                }

                if (shouldValidateSMSPhoneNo && isSMSConsent) {
                    var countryCode = FG.Utils.getCountryCode("#order-sms-phone-intl")
                    var phoneNumber = $('#intl-phone-input').val().trim();

                    var validatePhoneOptions = {
                        path: 'util/validate',
                        parameters: { phone: countryCode + phoneNumber, csrf_token: CSRF_TOKEN },
                        wait: 0,
                    };
                    FGTLibs.API.post(validatePhoneOptions)
                        .then(function(result) {
                            if (result && !result.valid) {
                                throw Error('server_invalid_phone');
                            }

                            $smsPhone.val(result.phone_number);

                            $('#smsPhoneErrorMissing').addClass('hidden');
                            checkoutSaveShipping();
                        }).catch(function(error) {
                            ladda.stop();

                            if (error.message === 'server_invalid_phone') {
                                $('#smsPhoneErrorMissing').addClass('hidden');
                                $('#smsPhoneError').removeClass('hidden');
                                $('#order-sms-phone-intl input[type="tel"]').addClass('invalid');
                                return;
                            }

                            window.location.reload();
                        });
                    return;
                }

                // At this point, the Customer has decided not to supply an SMS phone number.
                // Clear the hidden SMS Phone input before submitting.
                $smsPhone.val('');
                checkoutSaveShipping();

                function shouldValidateSMSPhone() {
                    isSMSConsent = $('#digital-delivery-opt-in').is(":checked") || $('#sms-order-tracking-opt-in').is(":checked");
                    var countryCode = FG.Utils.getCountryCode("#order-sms-phone-intl")
                    var phoneNumber = $('#intl-phone-input').val().trim();

                    if (isSMSConsent && ( !countryCode.length || !phoneNumber.length )) {
                        $('#smsPhoneError').addClass('hidden');
                        $('#smsPhoneErrorMissing').removeClass('hidden');
                        $('#order-sms-phone-intl input[type="tel"]').addClass('invalid');
                        ladda.stop();
                        return false;
                    }
                    return phoneNumber.trim().length > 0;
                }

                function resetShippingErrors() {
                    $('#smsPhoneError').addClass('hidden');
                    $('#phone-intl input[type="tel"]').removeClass('invalid');
                }

                function userSaveShipping() {
                    var payload = $shippingForm.serialize() + '&csrf_token=' + encodeURIComponent(CSRF_TOKEN);

                    try {
                        Ajax.setRequestData(payload);
                        Ajax.setMessageDiv('#msg-shipping');
                        Ajax.setLaddaButton(ladda);

                        Ajax.setSuccessCallback(function (FGResponse) {
                            setTimeout(function(){document.location.href = document.location.href;}, 1000);
                        });

                        Ajax.setFailureCallback(function (FGResponse) {
                            window.location.reload();
                        });

                        Ajax.send();
                    } catch (AjaxException) {
                        Ajax.error(AjaxException.msg);
                    }
                }

                function checkoutSaveShipping() {
                    var payload = $shippingForm.serialize() + '&csrf_token=' + encodeURIComponent(CSRF_TOKEN),
                        $disabledFields = $shippingForm.find('input, select').prop('disabled', true),
                        $disablePromoButton = $('.btn-apply-promo-code').prop('disabled', true);

                    try {
                        Ajax.setRequestData(payload);
                        Ajax.setMessageDiv('#msg-shipping');
                        Ajax.setLaddaButton(ladda);

                        Ajax.setSuccessCallback(function (FGResponse) {
                            if (pageType === 'user') {
                                setTimeout(function(){document.location.href = document.location.href;}, 1000);
                                return;
                            }

                            self.sendStepAndActionToECommerce('Delivery Method', shippingOptionsGTM);

                            if (
                                (self.previousOrderTotal === 0 && FGResponse.data.orderTotal > 0) ||
                                (self.previousOrderTotal > 0 && FGResponse.data.orderTotal === 0)
                            ) {
                                window.location.reload();
                                return false;
                            }

                            $('#braintree_token').val(FGResponse.data.clientToken);

                            if (FGResponse.data.orderTotal <= 0) {
                                $('#span-billing-address-title').html(window.FGTLibs.i18n.t('<h4>Contact Information</h4>'));
                                $('#div-form-free').removeClass('hide');
                                $('#div-form-paid').remove();
                                //Show a free msg in the summary.
                                $('#div-msg-promo-is-free').show();
                            } else {
                                $('#span-billing-address-title').html(window.FGTLibs.i18n.t('<h4>Billing Address</h4>'));
                                $('#div-form-free').addClass('hide');
                                $('#div-form-free').removeClass('braintreeZero');
                                $('#billing-next').removeClass('hide');
                                $('#div-msg-promo-is-free').hide();
                            }

                            self.setupBraintree();

                            ladda.stop();
                            $disabledFields.prop('disabled', false);
                            if ($('#promoCode').length && $('#promoCode').val().trim() !== '') {
                                $disablePromoButton.prop('disabled', false);
                            }

                            //Show an updated summary before the accordion closes
                            $('#div-summary-shipping').slideDown('slow',function () {
                                $(this).html(FGResponse.data.summary);
                            }).closest('#acc-step-one').addClass('complete');

                            // Billing section is coming into view. If a layaway plan is selected,
                            // re-render payment schedule so its amounts reflect the current shipping method.
                            var $planSchedule = $('#' + PLAN_SCHEDULE_CONTAINER);
                            var selectedPaymentPlanId = $('#paymentPlanId').val();
                            if ($planSchedule.children().length && selectedPaymentPlanId > 0) {
                                window.FGTLibs.renderPaymentSchedule({
                                    containerId: PLAN_SCHEDULE_CONTAINER,
                                    paymentPlanId: selectedPaymentPlanId,
                                });
                            }

                            // Determine whether to display the Attendee Capture accordion section
                            if ( $('#accordion-attendee-capture').length ) {
                                FG.Checkout.prototype.makeStepActive('attendee-capture-body');
                            } else {
                                FG.Checkout.prototype.makeStepActive('collapseTwo');
                            }

                            $btnShippingSubmit.removeAttr('disabled').removeClass('btn-loading');

                            $('#pp-paynow').val() == undefined ?
                                null : $('#pp-paynow').html($('#pp-paynow').html().replace(/\d{0,6}\.\d{1,2}/, FGResponse.data.orderTotal.toFixed(2)));

                            if (FGResponse.data.updatedInsurance != '') {
                                //update the insurance cost..cost may vary due to shipping selection
                                $('#insurance-cost').html(FGResponse.data.updatedInsurance);
                            }
                        });

                        Ajax.setFailureCallback(function (FGResponse) {
                            ladda.stop();
                            $disabledFields.prop('disabled', false);
                            if ($('#promoCode').length && $('#promoCode').val().trim() !== '') {
                                $disablePromoButton.prop('disabled', false);
                            }
                            $('#btn-shipping-submit').removeAttr('disabled').attr('disabled', false).val('Next');
                            //If the cart has expired, they need to get redirected to the cart expired page
                            if (FGResponse.errorType == 'CartExpiredException') {
                                //Redirect them to the cart expired page
                                window.location.href = $('#labelRoot').val() + '/cart/cart_expired';
                            } else if (FGResponse.errorType === 'CheckoutException' && FGResponse.error === 1 && FGResponse.errorCode === 400) {
                                //show error message
                                $('#phoneNumber').addClass('invalid');
                                $('#phoneErrorMessage:hidden').removeClass('hide');
                            }else if (FGResponse.errorType === 'SessionException') {
                                return false;
                            } else {
                                window.location.reload();
                                return false;
                            }
                        });

                        Ajax.send();
                    } catch (AjaxException) {
                        Ajax.error(AjaxException.msg);
                    }
                }

            });
        },

        /**
         * alter layaway plan options according to order total & layaway plans' min order
         */
        checkMinOrder: function () {
            var paymentPlanAvailable = false;

            $('#paymentPlanId option').each(function(){
                if (parseFloat($('#span-order-subtotal').data('base-and-service')) < parseFloat($(this).attr('min-order'))
                    || parseFloat($('#span-order-subtotal').data('total-base')) < parseFloat($(this).attr('min-base'))
                    || parseFloat($('#span-order-subtotal').data('total-service')) < parseFloat($(this).attr('min-service'))
                    || (parseFloat($(this).attr('max-order')) > 0
                        && parseFloat($('#span-order-subtotal').data('base-and-service')) >= parseFloat($(this).attr('max-order')))) {
                    $(this).remove();
                } else if ($(this).attr('min-order') && $(this).attr('max-order')) {
                    $(this).show();
                    paymentPlanAvailable = true;
                }
            })

            if (paymentPlanAvailable) {
                $('#paymentPlans').show();
                if ($('#pp-multiplepaymentplan').hasClass("btn-primary") && $('#paymentPlanId option:selected').val() == "") {
                    $('#div-form-paid').hide();
                }
            } else {
                $('#pp-paynow').click();
                $('#paymentPlans').hide();
            }
        },

        // Display Same as my shipping address option when mail is selected.
        displaySameAsShippingOption: function () {
            var selectedDeliveryOption = $('#shipping_form').find('select.cls-shopt-xticket option:selected');
            _isDeliveryOptionMail = selectedDeliveryOption.toArray().reduce(function (acc, element) {
                return $(element).data('serviceclass') === 'M' ? true : acc;
            }, false);

            if (_isDeliveryOptionMail) {
                // Not display same as my shipping address option when fan has already stored card.
                if (!$('#same-as-shipping-address').hasClass('storedCardActive')) {
                    $('#same-as-shipping-address').removeClass('hide');
                    $('#copy-shipping-address').attr('checked', _hasExistingBillingAddress ? false : true)
                }
            } else {
                $('#same-as-shipping-address').addClass('hide');
            }
        },

        copyShippingAddressToBilling: function () {
            var isShippingAndBillingSame = $('#billing_country').val() === $('#shipping_country').val();
            $('#billing_country').val($('#shipping_country').val());
            if (!isShippingAndBillingSame) {
                $('#billing_country').trigger('change', { copyState: true });
            } else {
                $('#billing_select_state').val($('#shipping_select_state').val());
            }
            $('#billing_address').val($('#shipping_address').val());
            $('#billing_address2').val($('#shipping_address2').val());
            $('#billing_city').val($('#shipping_city').val());
            $('#billing_zip').val($('#shipping_zip').val());
        },

        emptyBillingAddress: function () {
            $('#billing_address, #billing_address2, #billing_city, #billing_country, #billing_select_state, #billing_zip')
                .val('');
        },

        /**
         * Copy shipping data to billing data, if not empty
         */
        copyShippingToBilling: function () {

            var firstName = $('#shipping_firstName').val(),
                lastName = $('#shipping_lastName').val();

            if (!this.isValueValid($('#billing_firstName').val())) {
                if (!this.isValueValid(firstName)) {
                    firstName = $('#willcall_firstName').val();
                }
                $('#billing_firstName').val(firstName);
            }

            if (!this.isValueValid($('#billing_lastName').val())) {
                if (!this.isValueValid(lastName)) {
                    lastName = $('#willcall_lastName').val();
                }
                $('#billing_lastName').val(lastName);
            }

            this.ifNotSetReplace($('#billing_firstName_free'), firstName);
            this.ifNotSetReplace($('#billing_lastName_free'), lastName);

            // Don't copy address when fan has already billing address.
            if (!_hasExistingBillingAddress) {
                this.copyShippingAddressToBilling();
            }
        },

        /**
         * Show a modal that explains what a CVC number is on a credit card
         */
        bindToCVCHelpWindow: function () {
            $('#btn-cvc-help').on('click', function () {
                $('#modal-cvc').modal({
                    show: true,
                    backdrop: true,
                    keyboard: true
                }).animate('fast');
            });
        },

        /**
         * Brings the focus back to the triggering element when the modal closes
         */
        unbindFromCVCHelpWindow: function () {
            $("#modal-cvc").on("hidden.bs.modal", function () {
                $("#btn-cvc-help").focus();
            });
        },

        /**
         * Bind to the change event for the dropdown
         */
        bindToPaymentPlanDropdown: function () {
            var self = this;
            var paymentPlanId =  $('.multiple-payment-plans #paymentPlanId').val();

            $('#pp-multiplepaymentplan').on('click', function(e) {
                e.preventDefault();
                var $paymentPlanSelect = $('#paymentPlanId');

                if ($paymentPlanSelect.val().length <= 0) {
                    $('#div-form-paid, #billing_address_fields').hide();
                    $('#paymentMethods').addClass('hide');
                } else {
                    if ($('#paymentMethods').length) {
                        $('#paymentMethods').removeClass('hide');
                    } else {
                        $('#div-form-paid, #billing_address_fields').show();
                    }
                }
                $('.selectPaymentPlan').removeClass('hide');
                $('#pp-paynow').removeClass('btn-primary').addClass('buynotready');
                $('#pp-multiplepaymentplan').addClass('btn-primary').removeClass('buynotready');
                $('#paymentPlanErrorMessage').addClass('hide');
                $paymentPlanSelect.removeClass('border-danger').addClass('border');

                var plansLength = $paymentPlanSelect.find('option').length;

                // Auto-select 2nd option if only two (1st is placeholder)
                if (plansLength === 2) {
                    $paymentPlanSelect.find('option:eq(1)').prop('selected', true);
                    $paymentPlanSelect.trigger('change');
                // If multiple plans and one is already selected (not placeholder)
                // The change event displays the payment schedule and updates the order summary
                } else if (plansLength > 2) {
                    var $selectedPlan = $paymentPlanSelect.find('option:selected');
                    if ($selectedPlan.index() > 0) {
                        $paymentPlanSelect.trigger('change');
                    }
                }
            });

            if (paymentPlanId > 0) {
                $('#billing_address_fields, #div-form-paid').show();
                $('#collapseTwo').attr('style', 'height: auto;');
            }

            $('.multiple-payment-plans #paymentPlanId').on('change', function(e) {
                e.preventDefault();
                var paymentPlanId = $(this).val();
                $('#selectedPaymentPlanId').val($('#paymentPlanId').val());

                if (paymentPlanId > 0) {
                    var $schedule = $('#' + PLAN_SCHEDULE_CONTAINER);
                    if ($schedule.length) {
                        window.FGTLibs.renderPaymentSchedule({
                            containerId: PLAN_SCHEDULE_CONTAINER,
                            paymentPlanId: paymentPlanId,
                        });
                    }

                    $('#billing_address_fields, #div-form-paid').show();
                    $('#paymentMethods').removeClass('hide');
                    $('#collapseTwo').attr('style', 'height: auto;');
                } else {
                    window.FGTLibs.unmount(PLAN_SCHEDULE_CONTAINER);
                    $('#billing_address_fields, #div-form-paid').hide();
                    $('#paymentMethods').addClass('hide');

                    self.setOrderPayInFull();
                }

                //hide all the other ones
                $('.pp-description').addClass('hide');

                //Show the one in question
                $('#div-pp-description-' + paymentPlanId).removeClass('hide');

                //unselect the radio for pay in full
                $('#payment_plan_payInFull, #pp-paynow').removeAttr('checked');

                if ($('#paypalLogo:visible').length || $('#googlePayLogo:visible').length) {
                    $('#div-stored-card-option').removeClass('hide');
                }

                //Select the radio button for pay using selected and check the box to ensure user saves this card.
                $('#payment_plan_payUsingSelected, #billing_ccSave').prop('checked', true);

                var $termsModal = $('#ppmodal-terms');
                var $termsScroll = $('#ppmodal-terms .modal-scroll');

                $termsScroll.html($('#paymentPlanId option:selected').attr("pp-terms"));
                $termsScroll.append(
                    '<div class="scroll-end-message">' +
                        '<span class="material-symbols-outlined">check_circle</span>' +
                        '<span>' + window.FGTLibs.i18n.t('layaway.scroll_bottom_message') + '</span>' +
                    '</div>'
                );

                $termsModal.off('hide.bs.modal').on('hide.bs.modal', function () {
                    $termsScroll.scrollTop(0);
                });

                // If a layaway plan is selected
                if (self.isValueValid(paymentPlanId)) {
                    self.forcePPTermsToggle();

                    var fgCustom = $.cookie('FG_CUSTOM') ? JSON.parse($.cookie('FG_CUSTOM')) : null;

                    //if the user indicated they are a guest, force them to sign-in.
                    if (fgCustom != null && (fgCustom.isGuest && fgCustom.isGuest == 1)) {
                        $('#link-global-signin').click();
                    }

                    //Ensure that the "save my credit card" checkbox is checked, and disabled.
                    $('#billing_ccSave').prop('checked', true).prop('disabled', true);
                } else {
                    self.removeForcePPTermsToggle();
                }
            });

            //Guest, Show login modal
            $('#link-pp-signin').click(function () {
                $('#link-global-signin, #link-modal-tab-signin').click();
            });

            //Guest, Show create account modal
            $('#link-pp-create-account').click(function () {
                $('#link-global-signin, #link-modal-tab-signup').click();
            });

            $('#payment_plan_payInStepSingle, #pp-paymentplan').click(function () {

                var paymentPlanId = $('#paymentPlanId').val();
                $('#selectedPaymentPlanId').val(paymentPlanId);
                if (paymentPlanId > 0) {
                    $('#selectedPaymentPlanPreference').val('payUsingSelectedPlan');
                }

                if (self.isValueValid(paymentPlanId)) {

                    var fgCustom = $.cookie('FG_CUSTOM') ? JSON.parse($.cookie('FG_CUSTOM')) : null;

                    //if the user indicated they are a guest, force them to sign-in.
                    if (fgCustom != null && (fgCustom.isGuest && fgCustom.isGuest == 1)) {
                        $('#link-global-signin').click();
                    }

                    //Ensure that the "save my credit card" checkbox is checked, and disabled.
                    $('#billing_ccSave').prop('checked', true).prop('disabled', true);
                } else {
                    $('#paymentPlanId').val($(this).data('paymentplanid'));
                    self.removeForcePPTermsToggle();
                }

            });

        },

        activateNewPP : function () {
            var self = this;

            $('#pp-paymentplan').click(function(e) {
                $('#billing_address_fields, #div-form-paid').show();
                $('#payment_plan_payInStepSingle').click();
                $('#pp-paynow').removeAttr('checked');
                $('#pp-paymentplan').attr('checked', true);
                $('#pp-paymentplan').addClass('btn-primary').removeClass('buynotready');
                $('#pp-paynow').removeClass('btn-primary').addClass('buynotready');
                $('#billing-forms').show('slow');
                e.preventDefault();
                self.forcePPTermsToggle();
            });
            $('#pp-paynow').on('click', function(e) {
                // Gracefully unmounts the Plan Schedule if it loaded
                window.FGTLibs.unmount(PLAN_SCHEDULE_CONTAINER);
                $('#billing_address_fields, #div-form-paid').show();

                $('.pp-description').each(function() { $(this).addClass('hide') })

                $('#paymentMethods').removeClass('hide');
                $('#payment_plan_payInFull').click();
                $('#pp-paymentplan').removeAttr('checked');
                $('#pp-paynow, #pp-paymentplan, #pp-multiplepaymentplan').addClass('btn-primary').removeClass('buynotready');
                $('.selectPaymentPlan').addClass('hide');
                $('#billing-forms').show('slow');
                var $selectedPlanId = $('#selectedPaymentPlanId');
                var $talonOneCode = $('#isTalonOnePromoApplied');
                var $invalidPromoCode = $('#invalidPromoCode');
                if (
                    $selectedPlanId.length && $selectedPlanId.val() &&
                    $talonOneCode.length && $talonOneCode.val() &&
                    $invalidPromoCode.length && $invalidPromoCode.val()
                  ) {
                    $('.promoForm, .promo-success-wrapper').slideUp('slow');
                    $('.promo-code-header .toggle_promo_code[data-action="open"]').show();
                    $('.promo-code-header .toggle_promo_code[data-action="close"]').hide();
                    $('.btn-apply-promo-code').prop('disabled', true);
                    $('.promoForm input[name="promoCode"]').val('').removeClass('invalid').css('color', '#555');
                    $('.promoFailureMsg').empty();
                }
                $('#selectedPaymentPlanId').val('');
                if ($('#paypalLogo:visible').length || $('#googlePayLogo:visible').length) {
                    $('#billing_ccSave').attr('checked',false);
                    $('#div-stored-card-option').addClass('hide');
                }
                e.preventDefault();
                self.removeForcePPTermsToggle();
                
            });
        },

        /**
         * Ensure all user selections for layaway plans are maintained
         */
        ensurePaymentPlanSelections: function () {
            var $paymentPlanId = $('#paymentPlanId');

            if ($paymentPlanId.length > 0) {

                var selectedPaymentPlanPreference = $('#selectedPaymentPlanPreference').val();
                var selectedPaymentPlanId = $('#selectedPaymentPlanId').val();

                if (selectedPaymentPlanPreference == '' || selectedPaymentPlanPreference == undefined || selectedPaymentPlanPreference == 'payInFull') {
                    $('#payment_plan_payInFull').attr('checked', 'checked');
                } else {
                    $('#payment_plan_payUsingSelected').attr('checked', 'checked');
                }
                if (selectedPaymentPlanId != '' && selectedPaymentPlanId != undefined && selectedPaymentPlanId > 0) {
                    $paymentPlanId.val(selectedPaymentPlanId);
                }
            }
        },

        /**
         * Bind to the pay in full radio
         */
        bindToPayInFullRadio: function () {
            var self = this;

            $('#payment_plan_payInFull').on('change', function () {
                // Update the order if it is checked on the change event
                if ($(this).is(':checked')) {
                    self.setOrderPayInFull();
                }
            });

            $('#pp-paynow').on('click', function () {
                //Reset the paymentPlanId DD
                $('#paymentPlanId').val('');

                //Un-disable the CC save checkbox
                $('#billing_ccSave').removeAttr('disabled');
                $('#hidden_ccSave').remove();
            });
        },

        /**
         * Bind to links applicable to stored cards
         */
        bindToStoredCard: function () {
            var self = this;

            //Edit card link
            $('#link-edit-card').on('click', function (e) {
                e.preventDefault();
                $('#billing_ccNumber, #billing_ccExpMonth, #billing_ccExpYear').removeAttr('disabled').val('');
                $('#billing_ccSave').attr('checked', false);
            });

            //bind to do not use stored card
            $('#link-clear-card').on('click', function (e) {
                if (e) { e.preventDefault(); }
                $("[name='billingPhone'], #div-cvv, #btn-billing-submit, #link-ppterms-modal-force").removeClass("hideDiv");
                $('#msg-billing').hide();
                $('#doNotUseStoredCard').val('1');
                $('#stored-card-active').val('0');
                self.displayHostedFields();
                if (_isDeliveryOptionMail) {
                    $('#same-as-shipping-address').removeClass('hide');
                    $('#copy-shipping-address').attr('checked', false);
                }
                $('#billing_ccNumber, #billing_firstName, #billing_lastName, #billing_ccExpMonth, #billing_ccExpYear').removeAttr('disabled').val('');
                $('div.billing_ccNumber').removeClass(Object.keys(MY_BILLING_TYPES_ARRAY).join(' '));
                $('#title-card-details').removeClass('hide');
            });
        },

        /**
         * Bind to the click event for the final confirm purchase form
         */
        bindToPurchaseForm: function () {

            var self = this,
                $confirmForm = $('#confirm_form');

            var confirmationValidatorConfig = [
                { id: "confirm_email", type: ['required', 'noHTML', 'isEmail'] },
            ];
            var highlightInput = function(element, validation) {
                setTimeout(function() {
                    var msgId = $(element).attr('id').concat('-error');

                    if($(element).parents('form').find('div#' + msgId ).length > 0){
                            $(element).attr('aria-describedby', '');
                            $(element).parents('form').find('div#' + msgId ).remove();
                    }

                    $(element)[validation.pass ? 'removeClass' : 'addClass']('invalid');
                    $(element).parent()[validation.pass ? 'removeClass' : 'addClass']('invalid');


                    if (!validation.pass && validation.message !== '') {
                            var msgAttr = validation.message.toLowerCase().replace(/\s/g, '_');
                            if($(element).parents('form').find('div#' + msgId).length == 0){
                                    $(element).attr('aria-describedby', msgId);
                                    $(element).parent()
                                    .append('<div id="' + msgId + '" class="error-msg invalid" data-msg-text="' + msgAttr + '">' + validation.message + '</div>')
                                    .show();
                            }
                    }
                }, 150);
            };
            self.confirmationValidator = new FGTLibs.InputValidator(confirmationValidatorConfig, highlightInput);

            $("label[for='confirm_agree_store_card'] a").on("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
            });

            var isConfirmationValid = function() {
                var emailValid = self.confirmationValidator && self.confirmationValidator.checkAll().pass;
                var termsChecked = $('#confirm_agree_terms').is(':checked');
                var privacyChecked = !$('#privacy_policy_agreement').length || $('#confirm_agree_privacy_policy').is(':checked');

                var insuranceChecked = true;
                if ($('#agree_insurance_terms_block').is(':visible')) {
                    insuranceChecked = $('#confirm_agree_insurance_terms').is(':checked');
                }

                var storeCardChecked = true;
                if ($('#storedcards_terms_block').is(':visible')) {
                    storeCardChecked = $('#confirm_agree_store_card').is(':checked');
                }

                return emailValid && termsChecked && privacyChecked && insuranceChecked && storeCardChecked;
            };

            var highlightInvalidCheckboxes = function() {
                // Insurance terms
                if ($('#agree_insurance_terms_block').is(':visible')) {
                    $('#agree_insurance_terms_block').toggleClass('invalid', !$('#confirm_agree_insurance_terms').is(':checked'));
                }

                // Main terms
                $('#agree_terms_block').toggleClass('invalid', !$('#confirm_agree_terms').is(':checked'));

                // Privacy policy
                if ($('#privacy_policy_agreement').length) {
                    $('#agree_terms_block').toggleClass('invalid', !$('#confirm_agree_privacy_policy').is(':checked'));
                }

                // Credit card storage (includes layaway disclosure)
                if ($('#storedcards_terms_block').is(':visible')) {
                    $('#storedcards_terms_block').toggleClass('invalid', !$('#confirm_agree_store_card').is(':checked'));
                }
            };

            $confirmForm.unbind('submit').bind('submit', function (e) {
                e.preventDefault();
                var defaultErrorMessage = window.FGTLibs.i18n.t('There was a problem processing your payment. Please use a different card or method of payment.');

                function purchaseTickets() {
                    var Ajax;
                    var $purchaseTickets = $('#purchase_tickets');
                    //GTM
                    if (!$('#insurance_form').length) {
                        self.sendStepAndActionToECommerce('Secure Ticket', 'Not Available');
                    }

                    var paymentPlanId = $('#paymentPlanId').val();
                    //We may not have a dropdown, just a single PP
                    if (paymentPlanId == undefined) {
                        paymentPlanId = $('#selectedPaymentPlanId').val();
                    }

                    FG.SubmitData.email = document.getElementById('confirm_email').value;
                    FG.SubmitData.newsletterChecked = false;
                    FG.SubmitData.newsletterId = null;
                    FG.SubmitData.paymentPlanId = paymentPlanId;
                    FG.SubmitData.deviceData = self.deviceData;

                    //If the newsletter opt-in checkbox is present, send it to the server.

                    FG.SubmitData.newsletterIdArray = [];
                    $.each($('.newsletter_opt_in'), function (index, value) {
                        if ($(this).is(':checked')) {
                            FG.SubmitData.newsletterIdArray.push($(this).data('newsletterid'));
                        }
                    });

                    var firstName = $('#billing_firstName').val();
                    if (!self.isValueValid(firstName)) {
                        firstName = $('#billing_firstName_free').val();
                    }

                    var lastName = $('#billing_lastName').val();
                    if (!self.isValueValid(lastName)) {
                        lastName = $('#billing_lastName_free').val();
                    }

                    FG.SubmitData.billing_firstName = firstName;
                    FG.SubmitData.billing_lastName = lastName;
                    FG.SubmitData.billing_ccNumber = $('#billing_ccNumber').val();
                    FG.SubmitData.billing_ccSecurityCode = $('#billing_ccSecurityCode').val();
                    FG.SubmitData.billing_ccExpMonth = $('#billing_ccExpMonth').val();
                    FG.SubmitData.billing_ccExpYear = $('#billing_ccExpYear').val();
                    FG.SubmitData.confirm_agreeCardStorage = $('#confirm_agree_store_card').is(':checked');
                    FG.SubmitData.billing_address = $('#billing_address').val();
                    FG.SubmitData.billing_address_2 = $('#billing_address2').val();
                    FG.SubmitData.billing_country = $('#billing_country').val();
                    FG.SubmitData.billing_city = $('#billing_city').val();
                    FG.SubmitData.billing_state = $('#billing_select_state').val();
                    FG.SubmitData.billing_zip = $('#billing_zip').val();
                    FG.SubmitData.nonce = $('#nonce').val();
                    FG.SubmitData.csrf_token = CSRF_TOKEN;
                    //Disable the button
                    $purchaseTickets.html(window.FGTLibs.i18n.t('Please Wait...')).attr('disabled', 'disabled');

                    $('.order_confirmation_text').html('');

                    //Make a request out to the server
                    Ajax = new FG.AjaxJob('checkout/purchase');

                    try {
                        //Pause the timer
                        FG.CartTimer.pauseTimer();

                        var $modal = $('#modal-wait').modal({
                            backdrop: 'static',
                            keyboard: false
                        });

                        $modal.modal('show');

                        Ajax.setRequestData(FG.SubmitData);
                        Ajax.setMessageDiv('.order_confirmation_text');
                        Ajax.setSuccessCallback(function (FGResponse) {
                            if($("#NoAllianz").val() != 1) {
                                if($("#SecureAdd").val() === '1' && $("#AllianzProv").val() === "Allianz"){
                                    Allianz.doPurchaseRequestAllianz();
                                }
                                if($("#SecureAdd").val() !== '1' && $("#AllianzProv").val() === "Allianz"){
                                    Allianz.doDecisionRequestAllianz();
                                }
                            }

                            //GTM
                            var orderGTM = {
                                'email': $(this).data('email'),
                                'event': 'checkout',
                                ecommerce: {
                                    checkout: {
                                        actionField:{},
                                        products:[]
                                    }
                                }
                            };


                            $('.cost-breakout .cart-event-info').each(function(){
                                // product GTM
                                orderGTM.ecommerce.checkout.products.push({
                                    name: $(this).data('eventname'),
                                    id: $(this).data('eventid'),
                                    price: $(this).data('price'),
                                    category: $(this).data('category'),
                                    quantity: $(this).data('quantity'),
                                    variant: $(this).data('variant')
                                });
                            });

                            dataLayer.push(orderGTM);

                            if (FGResponse.data.location == 'undefined' || FGResponse.data.location == undefined) {
                                window.location.href = $('#labelRoot').val() + '/checkout/thank_you';
                            } else {
                                window.location.href = FGResponse.data.location;
                            }

                            FG.CartTimer.deleteTimer();


                        });

                        Ajax.setFailureCallback(function (FGResponse) {
                            $('.order_confirmation_text').html('').removeClass('hide')

                            //Unpause the cart timer; thou shall pay for your mistakes with the sand of time
                            FG.CartTimer.unpauseTimer();

                            if (FGResponse != undefined) {
                                $modal.modal('hide');
                                //Enable the purchase button
                                $purchaseTickets.html(window.FGTLibs.i18n.t('Purchase Tickets')).removeAttr('disabled').attr('disabled', false);

                                if (FGResponse.errorType == 'InvalidLayawayPlanException') {
                                    $('.order_confirmation_text').html(window.FGTLibs.i18n.t('Invalid layaway plan. Please select a different layaway plan to complete your purchase.')).show().removeClass('alert-success').delay(9000).fadeOut();
                                }

                                if (shouldValidate3DSecure() && FGResponse.errorType === 'TransactionException') {
                                    showPaymentSectionWithError();
                                    return false;
                                }

                                //Handle a specific order cancelled exception, because they ran out of time or too many failures
                                if (FGResponse.errorType == 'OrderCancelledException') {

                                    $purchaseTickets.remove();

                                    setTimeout(function () {
                                        window.location.href = $('#labelRoot').val() + '/cart/cart_expired';
                                    }, 3000);
                                }

                                //If we have an invalid credit card
                                if (FGResponse.errorType == 'CardValidatorException') {
                                    //make the billing step active
                                    self.makeStepActive('collapseTwo');

                                    //make the billing error messge div active and show error reason
                                    FG.Utils.showError('msg-billing', FGResponse.msg);
                                    //focus on the CC number field as dates and CVV is not being validated at the gateway level
                                    $('#billing_ccNumber').focus();
                                }

                                //If the session is locked, they tried to purchase again, so, we recurse.
                                if (FGResponse.errorType == 'SessionLockedException') {
                                    FGResponse.isJob = true;

                                    Ajax.revaluateResponse(FGResponse);
                                }

                                if (FGResponse.errorType == 'ResponseEmptyException' && FGResponse.msg != '') {
                                    //make the billing error messge div active and show error reason
                                    FG.Utils.showError('msg-billing', FGResponse.msg);

                                }
                            }
                        });
                        Ajax.send();

                    } catch (AjaxException) {
                        Ajax.error(AjaxException.msg);
                        $('#purchase_tickets').html(window.FGTLibs.i18n.t('Purchase Tickets')).removeAttr('disabled').attr('disabled', false);
                    }
                }

                function disablePurchaseButton() {
                    $('#purchase_tickets').html(window.FGTLibs.i18n.t('Please Wait...')).attr('disabled', 'disabled');
                }

                function enablePurchaseButton() {
                    $('#purchase_tickets').html(window.FGTLibs.i18n.t('Purchase Tickets')).removeAttr('disabled');
                }

                function shouldValidate3DSecure() {
                    return (
                        self.isThreeDSecureEnabled &&
                        document.getElementById('span-order-subtotal').dataset.theTotal > 0 &&
                        (self.paymentTracker && self.paymentTracker.canUse3DSecure)
                    );
                }

                function showPaymentSectionWithError() {
                    self.makeStepActive('collapseTwo');
                    $('#payment-alert')
                        .html(defaultErrorMessage)
                        .show()
                        .delay(9000)
                        .fadeOut();
                }

                // validate email address and check boxes
                if (!isConfirmationValid()) {
                    highlightInvalidCheckboxes();
                    return false;
                }

                // At this point, go through the 3DSecure code or just try to purchase tickets
                // -----
                // If the use secure input is in the DOM AND they're not using paypal to purchase
                // Run the 3d Secure Verification
                function onLookupComplete(data, next) {
                    next();
                }
                if (shouldValidate3DSecure()) {
                    disablePurchaseButton();

                    var threeDData = FGTLibs.UpdateCheckout.threeDParser.parseCheckout();
                    var nonceBin = self.braintreeAPI.getNonceBin();
                    threeDData.nonce = nonceBin.nonce;
                    threeDData.bin = nonceBin.bin;
                    threeDData.onLookupComplete = onLookupComplete;
                    threeDData.collectDeviceData = true;

                    self.braintreeAPI.threeDSecureInstance.verifyCard(threeDData)
                        .then(function(response) {
                            // Replace the existing nonce with the 3d secure nonce
                            document.getElementById('nonce').value = response.nonce;
                            purchaseTickets();
                        })
                        .catch(function(error) {
                            // Don't bugsnag 3ds tokenized card not found error
                            if (error.code !== 'THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR') {
                                FGTLibs.Bugsnag.log(error);
                            }
                            showPaymentSectionWithError();
                            enablePurchaseButton();
                        });
                }
                else {
                    purchaseTickets();
                }
            });

            var updatePurchaseButtons = function() {
                var isValid = isConfirmationValid();

                // Update regular purchase button
                $('#purchase_tickets').prop('disabled', !isValid).attr('aria-disabled', isValid ? 'false' : 'true');

                self.setApplePayButtonEnabled(isValid);
            };

            // Set up event handlers for real-time validation
            $('#confirm_agree_insurance_terms').on('change', function() {
                $('#agree_insurance_terms_block').toggleClass('invalid', !$(this).is(':checked'));
                updatePurchaseButtons();
            });

            $('#confirm_agree_terms').on('change', function() {
                $('#agree_terms_block').toggleClass('invalid', !$(this).is(':checked'));
                updatePurchaseButtons();
            });

            if ($('#privacy_policy_agreement').length) {
                $('#confirm_agree_privacy_policy').on('change', function() {
                    $('#agree_terms_block').toggleClass('invalid', !$(this).is(':checked'));
                    updatePurchaseButtons();
                });
            }

            $('#confirm_agree_store_card').on('change', function() {
                $('#storedcards_terms_block').toggleClass('invalid', !$(this).is(':checked'));
                updatePurchaseButtons();
            });

            $('#confirm_email').on('input change', updatePurchaseButtons);

            // Initial button state
            updatePurchaseButtons();
        },

        /**
         * Bind to to the modal for the terms of service link
         */
        bindToPPTermsModal: function () {
            // Reuses the layaway terms modal for viewing only
            $('.link-ppterms-modal').on('click', function () {
                var $termsScroll = $('#ppmodal-terms .modal-scroll');
                // Populate the content from the selected payment plan
                var termsContent = $('#paymentPlanId option:selected').attr("pp-terms");
                if (termsContent) {
                    $termsScroll.html(termsContent);
  
                    $termsScroll.append(
                        '<div class="scroll-end-message">' +
                            '<span class="material-symbols-outlined">check_circle</span>' +
                            '<span>' + window.FGTLibs.i18n.t('layaway.scroll_bottom_message') + '</span>' +
                        '</div>'
                    );
                }

                $('#ppmodal-terms').modal({ backdrop: true, keyboard: true, show: true });

                // Hide the agreement related elements
                $('#ppmodal-terms #terms-accept-btn').hide();
                $('#ppmodal-terms .scroll-instructions').hide();
            });
        },

        forcePPTermsToggle: function() {
            var $btnBillingSubmit = $('#btn-billing-submit');
            var $modal = $('#ppmodal-terms');
            var $modalScroll = $modal.find('.modal-scroll');
            var $termsAcceptBtn = $modal.find('#terms-accept-btn');
            var $scrollInstructions = $modal.find('.scroll-instructions');

            // Show layaway disclosure text on confirmation step
            $('#layaway-disclosure-text').removeClass('hide');

            $btnBillingSubmit.unbind('click').attr('id', 'link-ppterms-modal-force').bind('click', function (e) {
                e.preventDefault();

                // Show modal elements and reset state
                $termsAcceptBtn.show().prop('disabled', true).text(window.FGTLibs.i18n.t('layaway.scroll_accept_prompt'));
                $scrollInstructions.show();
                
                // Reset scroll position after modal renders
                setTimeout(function() {
                    $modalScroll.scrollTop(0);
                }, 200);

                $modal.modal({ backdrop: true, keyboard: false, show: true });

                // Handle configuring the Accept Button based on scroll position
                $modalScroll.off('scroll').on('scroll', function () {
                    var isScrolledToBottom = $(this).scrollTop() + $(this).innerHeight() + 2 >= $(this)[0].scrollHeight;
                    
                    if (isScrolledToBottom) {
                        $termsAcceptBtn.prop('disabled', false).text(window.FGTLibs.i18n.t('Accept Terms'));
                    }
                });

                $termsAcceptBtn.off('click').on('click', function(e) {
                    e.preventDefault();

                    $('#link-ppterms-modal-force').unbind('click').attr('id', 'btn-billing-submit');
                    // Iphones and Macs
                    setTimeout(function(){ $('#btn-billing-submit').click() }, 100);
                });
            });
        },

        removeForcePPTermsToggle: function() {
            $('#link-ppterms-modal-force').unbind('click').attr('id', 'btn-billing-submit');
            // Hide layaway disclosure text on confirmation step
            $('#layaway-disclosure-text').addClass('hide');
        },

        /**
         * Bind to to the modal for the terms of service link
         */
        bindToTermsModal: function () {
            $('.link-terms-modal').on('click', function () {
                $('#modal-terms').modal({ backdrop: true, keyboard: true, show: true });
            });
        },

        /**
         * Bind to to the modal for the terms for insurance
         */
        bindToInsuranceTermsWindow: function () {
            $('#btn-insurance-terms, #btn-insurance-terms2').on('click', function () {
                $.get(document.location.protocol + '//' + document.location.hostname + '/label/secure-ticket-terms.modal').done(function (html) {
                    $(html).modal({ show: true, backdrop: true, keyboard: true });
                });
            });
        },

        /**
         * Make an accordion step active
         * @param {string}  stepId  DOM ID of step we are referring to.
         */
        makeStepActive: function (stepId) {
            FG.Checkout.isNextStep = true;

            var $nextStep = $("a[href='#" + stepId + "']"),
                $nextStepGroup = $nextStep.closest('.panel.panel-default'),
                $prevStepGroup = $nextStepGroup.prev();

            if ($prevStepGroup.length == 0) { $prevStepGroup = $nextStepGroup; }

            $nextStep.slideDown('slow', function() {
                var $prevStepHeading = $prevStepGroup.find('.panel-heading');
                $('html, body').animate({scrollTop : $prevStepHeading.offset().top + $prevStepHeading.height()}, 'slow');
            }).trigger('click');
        },

        isFreeBraintree: function() { return $('#div-form-free').hasClass('braintreeZero'); },
    };
}());

$(function() {
    // determine what layaway plans are available on each page load
    $(document).ready(function(){ FG.Checkout.prototype.checkMinOrder(); });

    var clickOnceYes = 0, clickOnceNo = 0;

    $('.shipping-title').css('color', '#' + $('#mainContent').attr('data-accentcolor'));

    //On page load if insurance is checked show the insurance terms agreement
    $('#agree_insurance_terms_block').toggle($('#insurance').is(':checked') == true);

    if ($('#same-as-shipping-address').length) {
        $('#copy-shipping-address').on('change', function () {
            $(this).is(':checked') ?
                FG.Checkout.prototype.copyShippingAddressToBilling()
                : FG.Checkout.prototype.emptyBillingAddress();
        });
    }

    /*
     * Use the hidden Secure Ticket toggle and let it do its thing but present it as a button for
     * saying "yes I want protection" or "no I do not want protection"
     */
    $('#insurance-cost').hide();

    /**
     * This portion of code was moved to a dinamically accesible place on accordion2.twig tamplate.
     */
    $('#btn-insurance-yes').on('click', function() {
        $('#insurance').prop('checked', true);
        $('#agree_insurance_terms_block').show();

        FG.Checkout.prototype.sendStepAndActionToECommerce('Secure Ticket', 'Add/Accept');

        // Only track one button click per page load so analytics is more reasonable
        // insuranceCost is provided in the template insurance_cost_partial.twig
        clickOnceYes++;
    });

    $('#btn-insurance-no').on('click', function(e) {
        $('#insurance').prop('checked', false);
        $('#agree_insurance_terms_block').hide();

        var optionGTM = 'No Thanks';
        if(!e.hasOwnProperty('originalEvent')){
            optionGTM = 'Not available at this time';
            if ($('#billing_state_other').val() == 'XX' || $('#billing_country').val() != 'United States') {
                optionGTM = 'Not available in this country/state';
            }
        }

        FG.Checkout.prototype.sendStepAndActionToECommerce('Secure Ticket', optionGTM);

        //Only track one button click per page load so analytics is more reasonable
        clickOnceNo++;
    });

    $('#btn-insurance-allianz-next').on('click', function() {

        $("#insuranceAllianzSelection").removeClass('hide');
        var insuranceAllianzAccepted = $('#btn-insurance-yes').is(':checked');
        var insuranceAllianzNotAccepted = $('#btn-insurance-no').is(':checked');

        // Validate Allianz accepted or not to show or hide text
        if(insuranceAllianzAccepted && !insuranceAllianzNotAccepted) {
            $("#insuranceAllianzAcceptedText").removeClass('hide');
            $("#insuranceAllianzDeclinedText").addClass('hide');
        } else if(!insuranceAllianzAccepted && insuranceAllianzNotAccepted){
            $("#insuranceAllianzAcceptedText").addClass('hide');
            $("#insuranceAllianzDeclinedText").removeClass('hide');
        } else {
            $("#insuranceAllianzDeclinedText").addClass('hide');
            $("#insuranceAllianzAcceptedText").addClass('hide');
        }

        if ($('#allianzResponse #insurance_form'))
            $('#allianzResponse #insurance_form').submit();
            $.ajax({
                method: "POST",
                url: $("#labelRoot").val() + "/checkout/get_fan_insurance_decision",
                data: { 'json': insuranceAllianzAccepted, csrf_token: FG.Utils.getToken()},
                async: true
              }).done(function () {
                return true;
              });
    });

    $('#btn-insurance-not-available').on('click', function() {
        $('#btn-insurance-no').click();
        if ($('#allianzResponse #insurance_form'))
            $('#allianzResponse #insurance_form').submit();
    });

    $('#btn-insurance-venmo-not-available').on('click', function() {
        $('#btn-insurance-no').click();
        $('#allianzResponse #insurance_form').submit();
    });

    $('#shippingEdit #shippingEditBtn').click(function() {
        if ($('#shippingEdit #shippingEditBtn').text() === window.FGTLibs.i18n.t('Edit')) {
            $('#shippingEdit #shippingEditBtn').text(window.FGTLibs.i18n.t('Cancel'));
            $('#shippingEdit .country').show();
            $('#shippingEdit .shippingSave, #scs-M').show();
            $('#shippingEdit .contactDisplayWrap, #scs-M h4').hide();

            var Checkout = new FG.Checkout();
            Checkout.hydrate();
            Checkout.bindToShippingForm('user');
            Checkout.buildOrderHistoryStateDD( {'countryName' : $('#shipping_country').val() } );

            $('#shipping_country').unbind().on('change', function () {
                Checkout.buildOrderHistoryStateDD({ 'countryName': $(this).val() });
            });
        } else {
            // Reset country and state to previous selected values when cancelling edits
            $('#shipping_country').val($('#shipping_country').find("option[selected]").val());
            $('#shipping_select_state').val($('#shipping_select_state').find("option[selected]").val());

            $('#shippingEdit #shippingEditBtn').text(window.FGTLibs.i18n.t('Edit'));
            $('#shippingEdit .shippingSave, #scs-M').hide();
            $('#shippingEdit .country').hide();
            $('#shippingEdit .contactDisplayWrap').show();
        }
    });
});
